import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { RELAYER_DEFAULT_PROTOCOL as tt, RELAYER_EVENTS as qe, VERIFY_SERVER as st, EXPIRER_EVENTS as it, PAIRING_EVENTS as Ne, Store as K, Core as rt } from "@walletconnect/core";
import { pino as nt, getDefaultLoggerOptions as ot, generateChildLogger as at, getLoggerContext as ct } from "@walletconnect/logger";
import { IEngine as lt, ISignClient as ht } from "@walletconnect/types";
import { getInternalError as l, calcExpiry as N, createDelayedPromise as U, engineEvent as u, getSdkError as R, getDeepLink as pt, handleDeeplinkRedirect as dt, isSessionCompatible as ut, hashKey as ue, parseChainId as ge, createEncodedRecap as gt, getRecapFromResources as we, mergeEncodedRecaps as wt, validateSignedCacao as Pe, getNamespacedDidChainId as ve, getDidAddress as Oe, getMethodsFromRecap as Te, getChainsFromRecap as De, buildNamespacesFromAuth as xe, formatMessage as yt, isBrowser as mt, hashMessage as ee, isExpired as G, MemoryStore as H, isValidParams as T, isUndefined as Y, isValidRelays as St, isValidObject as Ae, isValidRequiredNamespaces as Et, isValidNamespaces as ye, isConformingNamespaces as Ve, isValidString as V, isValidErrorReason as _t, isValidRelay as Rt, isValidController as It, isValidNamespacesChainId as Ce, isValidRequest as ft, isValidNamespacesRequest as qt, isValidRequestExpiry as Nt, isValidResponse as Pt, isValidEvent as vt, isValidNamespacesEvent as Ot, parseExpirerTarget as Tt, isValidId as Dt, TYPE_1 as be, getAppMetadata as xt } from "@walletconnect/utils";
import At, { EventEmitter as Vt } from "events";
import { THIRTY_DAYS as Ct, SEVEN_DAYS as $e, FIVE_MINUTES as x, ONE_DAY as C, ONE_HOUR as Le, ONE_SECOND as bt, toMiliseconds as Me } from "@walletconnect/time";
import { payloadId as k, getBigIntRpcId as te, isJsonRpcResult as b, isJsonRpcError as $, formatJsonRpcRequest as me, formatJsonRpcResult as $t, formatJsonRpcError as Lt, isJsonRpcRequest as Mt, isJsonRpcResponse as Kt } from "@walletconnect/jsonrpc-utils";
var Se = "wc",
  Ee = 2,
  _e = "client",
  se = "".concat(Se, "@").concat(Ee, ":").concat(_e, ":"),
  ie = {
    name: _e,
    logger: "error",
    controller: !1,
    relayUrl: "wss://relay.walletconnect.com"
  },
  Ut = {
    session_proposal: "session_proposal",
    session_update: "session_update",
    session_extend: "session_extend",
    session_ping: "session_ping",
    session_delete: "session_delete",
    session_expire: "session_expire",
    session_request: "session_request",
    session_request_sent: "session_request_sent",
    session_event: "session_event",
    proposal_expire: "proposal_expire",
    session_authenticate: "session_authenticate",
    session_request_expire: "session_request_expire"
  },
  Gt = {
    database: ":memory:"
  },
  Re = "WALLETCONNECT_DEEPLINK_CHOICE",
  kt = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
  },
  Ft = "history",
  jt = "0.3",
  Ke = "proposal",
  Qt = Ct,
  Ue = "Proposal expired",
  Ge = "session",
  L = $e,
  ke = "engine",
  q = {
    wc_sessionPropose: {
      req: {
        ttl: x,
        prompt: !0,
        tag: 1100
      },
      res: {
        ttl: x,
        prompt: !1,
        tag: 1101
      }
    },
    wc_sessionSettle: {
      req: {
        ttl: x,
        prompt: !1,
        tag: 1102
      },
      res: {
        ttl: x,
        prompt: !1,
        tag: 1103
      }
    },
    wc_sessionUpdate: {
      req: {
        ttl: C,
        prompt: !1,
        tag: 1104
      },
      res: {
        ttl: C,
        prompt: !1,
        tag: 1105
      }
    },
    wc_sessionExtend: {
      req: {
        ttl: C,
        prompt: !1,
        tag: 1106
      },
      res: {
        ttl: C,
        prompt: !1,
        tag: 1107
      }
    },
    wc_sessionRequest: {
      req: {
        ttl: x,
        prompt: !0,
        tag: 1108
      },
      res: {
        ttl: x,
        prompt: !1,
        tag: 1109
      }
    },
    wc_sessionEvent: {
      req: {
        ttl: x,
        prompt: !0,
        tag: 1110
      },
      res: {
        ttl: x,
        prompt: !1,
        tag: 1111
      }
    },
    wc_sessionDelete: {
      req: {
        ttl: C,
        prompt: !1,
        tag: 1112
      },
      res: {
        ttl: C,
        prompt: !1,
        tag: 1113
      }
    },
    wc_sessionPing: {
      req: {
        ttl: C,
        prompt: !1,
        tag: 1114
      },
      res: {
        ttl: C,
        prompt: !1,
        tag: 1115
      }
    },
    wc_sessionAuthenticate: {
      req: {
        ttl: Le,
        prompt: !0,
        tag: 1116
      },
      res: {
        ttl: Le,
        prompt: !1,
        tag: 1117
      }
    }
  },
  re = {
    min: x,
    max: $e
  },
  A = {
    idle: "IDLE",
    active: "ACTIVE"
  },
  Fe = "request",
  je = ["wc_sessionPropose", "wc_sessionRequest", "wc_authRequest"],
  Qe = "wc",
  zt = 1.5,
  ze = "auth",
  He = "authKeys",
  Ye = "pairingTopics",
  Xe = "requests",
  X = "".concat(Qe, "@", 1.5, ":").concat(ze, ":"),
  J = "".concat(X, ":PUB_KEY");
var Ht = Object.defineProperty,
  Yt = Object.defineProperties,
  Xt = Object.getOwnPropertyDescriptors,
  Je = Object.getOwnPropertySymbols,
  Jt = Object.prototype.hasOwnProperty,
  Bt = Object.prototype.propertyIsEnumerable,
  Be = function Be(S, n, t) {
    return n in S ? Ht(S, n, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : S[n] = t;
  },
  m = function m(S, n) {
    for (var t in n || (n = {})) Jt.call(n, t) && Be(S, t, n[t]);
    if (Je) {
      var _iterator = _createForOfIteratorHelper(Je(n)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var t = _step.value;
          Bt.call(n, t) && Be(S, t, n[t]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return S;
  },
  F = function F(S, n) {
    return Yt(S, Xt(n));
  };
var Wt = /*#__PURE__*/function (_lt) {
  _inherits(Wt, _lt);
  var _super = _createSuper(Wt);
  function Wt(n) {
    var _this;
    _classCallCheck(this, Wt);
    _this = _super.call(this, n), _this.name = ke, _this.events = new At(), _this.initialized = !1, _this.requestQueue = {
      state: A.idle,
      queue: []
    }, _this.sessionRequestQueue = {
      state: A.idle,
      queue: []
    }, _this.requestQueueDelay = bt, _this.expectedPairingMethodMap = new Map(), _this.recentlyDeletedMap = new Map(), _this.recentlyDeletedLimit = 200, _this.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = _this.initialized;
            if (_context.t0) {
              _context.next = 10;
              break;
            }
            _context.next = 4;
            return _this.cleanup();
          case 4:
            _this.registerRelayerEvents();
            _this.registerExpirerEvents();
            _this.registerPairingEvents();
            _this.client.core.pairing.register({
              methods: Object.keys(q)
            });
            _this.initialized = !0;
            setTimeout(function () {
              _this.sessionRequestQueue.queue = _this.getPendingSessionRequests(), _this.processSessionRequestQueue();
            }, Me(_this.requestQueueDelay));
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), _this.connect = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
        var e, s, i, r, o, a, c, d, p, _yield$_this$client$c, f, v, _l, _f, g, h, y, w, _U, I, D, E, P;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.isInitialized();
            case 2:
              e = F(m({}, t), {
                requiredNamespaces: t.requiredNamespaces || {},
                optionalNamespaces: t.optionalNamespaces || {}
              });
              _context3.next = 5;
              return _this.isValidConnect(e);
            case 5:
              s = e.pairingTopic, i = e.requiredNamespaces, r = e.optionalNamespaces, o = e.sessionProperties, a = e.relays;
              c = s, p = !1;
              _context3.prev = 7;
              c && (p = _this.client.core.pairing.pairings.get(c).active);
              _context3.next = 14;
              break;
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](7);
              throw _this.client.logger.error("connect() -> pairing.get(".concat(c, ") failed")), _context3.t0;
            case 14:
              if (!(!c || !p)) {
                _context3.next = 21;
                break;
              }
              _context3.next = 17;
              return _this.client.core.pairing.create();
            case 17:
              _yield$_this$client$c = _context3.sent;
              f = _yield$_this$client$c.topic;
              v = _yield$_this$client$c.uri;
              c = f, d = v;
            case 21:
              if (c) {
                _context3.next = 24;
                break;
              }
              _l = l("NO_MATCHING_KEY", "connect() pairing topic: ".concat(c)), _f = _l.message;
              throw new Error(_f);
            case 24:
              _context3.next = 26;
              return _this.client.core.crypto.generateKeyPair();
            case 26:
              g = _context3.sent;
              h = q.wc_sessionPropose.req.ttl || x;
              y = N(h);
              w = m({
                requiredNamespaces: i,
                optionalNamespaces: r,
                relays: a !== null && a !== void 0 ? a : [{
                  protocol: tt
                }],
                proposer: {
                  publicKey: g,
                  metadata: _this.client.metadata
                },
                expiryTimestamp: y
              }, o && {
                sessionProperties: o
              });
              _U = U(h, Ue);
              I = _U.reject;
              D = _U.resolve;
              E = _U.done;
              _this.events.once(u("session_connect"), /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
                  var f, v, j;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        f = _ref3.error, v = _ref3.session;
                        if (!f) {
                          _context2.next = 5;
                          break;
                        }
                        I(f);
                        _context2.next = 17;
                        break;
                      case 5:
                        if (!v) {
                          _context2.next = 17;
                          break;
                        }
                        v.self.publicKey = g;
                        j = F(m({}, v), {
                          requiredNamespaces: w.requiredNamespaces,
                          optionalNamespaces: w.optionalNamespaces
                        });
                        _context2.next = 10;
                        return _this.client.session.set(v.topic, j);
                      case 10:
                        _context2.next = 12;
                        return _this.setExpiry(v.topic, v.expiry);
                      case 12:
                        _context2.t0 = c;
                        if (!_context2.t0) {
                          _context2.next = 16;
                          break;
                        }
                        _context2.next = 16;
                        return _this.client.core.pairing.updateMetadata({
                          topic: c,
                          metadata: v.peer.metadata
                        });
                      case 16:
                        D(j);
                      case 17:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }());
              _context3.next = 37;
              return _this.sendRequest({
                topic: c,
                method: "wc_sessionPropose",
                params: w,
                throwOnFailedPublish: !0
              });
            case 37:
              P = _context3.sent;
              _context3.next = 40;
              return _this.setProposal(P, m({
                id: P
              }, w));
            case 40:
              return _context3.abrupt("return", {
                uri: d,
                approval: E
              });
            case 41:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[7, 11]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.pair = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this.isInitialized();
            case 2:
              _context4.prev = 2;
              _context4.next = 5;
              return _this.client.core.pairing.pair(t);
            case 5:
              return _context4.abrupt("return", _context4.sent);
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](2);
              throw _this.client.logger.error("pair() failed"), _context4.t0;
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[2, 8]]);
      }));
      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }(), _this.approve = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(t) {
        var e, s, i, r, o, a, _a, c, d, p, g, h, y, w, I, D;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this.isInitialized();
            case 2:
              _context5.prev = 2;
              _context5.next = 5;
              return _this.isValidApprove(t);
            case 5:
              _context5.next = 10;
              break;
            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](2);
              throw _this.client.logger.error("approve() -> isValidApprove() failed"), _context5.t0;
            case 10:
              e = t.id, s = t.relayProtocol, i = t.namespaces, r = t.sessionProperties, o = t.sessionConfig;
              _context5.prev = 11;
              a = _this.client.proposal.get(e);
              _context5.next = 18;
              break;
            case 15:
              _context5.prev = 15;
              _context5.t1 = _context5["catch"](11);
              throw _this.client.logger.error("approve() -> proposal.get(".concat(e, ") failed")), _context5.t1;
            case 18:
              _a = a, c = _a.pairingTopic, d = _a.proposer, p = _a.requiredNamespaces, g = _a.optionalNamespaces;
              c = c || "";
              _context5.next = 22;
              return _this.client.core.crypto.generateKeyPair();
            case 22:
              h = _context5.sent;
              y = d.publicKey;
              _context5.next = 26;
              return _this.client.core.crypto.generateSharedKey(h, y);
            case 26:
              w = _context5.sent;
              I = m(m({
                relay: {
                  protocol: s !== null && s !== void 0 ? s : "irn"
                },
                namespaces: i,
                pairingTopic: c,
                controller: {
                  publicKey: h,
                  metadata: _this.client.metadata
                },
                expiry: N(L)
              }, r && {
                sessionProperties: r
              }), o && {
                sessionConfig: o
              });
              _context5.next = 30;
              return _this.client.core.relayer.subscribe(w);
            case 30:
              D = F(m({}, I), {
                topic: w,
                requiredNamespaces: p,
                optionalNamespaces: g,
                pairingTopic: c,
                acknowledged: !1,
                self: I.controller,
                peer: {
                  publicKey: d.publicKey,
                  metadata: d.metadata
                },
                controller: h
              });
              _context5.next = 33;
              return _this.client.session.set(w, D);
            case 33:
              _context5.prev = 33;
              _context5.next = 36;
              return _this.sendResult({
                id: e,
                topic: c,
                result: {
                  relay: {
                    protocol: s !== null && s !== void 0 ? s : "irn"
                  },
                  responderPublicKey: h
                },
                throwOnFailedPublish: !0
              });
            case 36:
              _context5.next = 38;
              return _this.sendRequest({
                topic: w,
                method: "wc_sessionSettle",
                params: I,
                throwOnFailedPublish: !0
              });
            case 38:
              _context5.next = 47;
              break;
            case 40:
              _context5.prev = 40;
              _context5.t2 = _context5["catch"](33);
              _this.client.logger.error(_context5.t2);
              _this.client.session.delete(w, R("USER_DISCONNECTED"));
              _context5.next = 46;
              return _this.client.core.relayer.unsubscribe(w);
            case 46:
              throw _context5.t2;
            case 47:
              _context5.next = 49;
              return _this.client.core.pairing.updateMetadata({
                topic: c,
                metadata: d.metadata
              });
            case 49:
              _context5.next = 51;
              return _this.client.proposal.delete(e, R("USER_DISCONNECTED"));
            case 51:
              _context5.next = 53;
              return _this.client.core.pairing.activate({
                topic: c
              });
            case 53:
              _context5.next = 55;
              return _this.setExpiry(w, N(L));
            case 55:
              return _context5.abrupt("return", {
                topic: w,
                acknowledged: function acknowledged() {
                  return new Promise(function (E) {
                    return setTimeout(function () {
                      return E(_this.client.session.get(w));
                    }, 500);
                  });
                }
              });
            case 56:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[2, 7], [11, 15], [33, 40]]);
      }));
      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }(), _this.reject = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(t) {
        var e, s, i;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this.isInitialized();
            case 2:
              _context6.prev = 2;
              _context6.next = 5;
              return _this.isValidReject(t);
            case 5:
              _context6.next = 10;
              break;
            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](2);
              throw _this.client.logger.error("reject() -> isValidReject() failed"), _context6.t0;
            case 10:
              e = t.id, s = t.reason;
              _context6.prev = 11;
              i = _this.client.proposal.get(e).pairingTopic;
              _context6.next = 18;
              break;
            case 15:
              _context6.prev = 15;
              _context6.t1 = _context6["catch"](11);
              throw _this.client.logger.error("reject() -> proposal.get(".concat(e, ") failed")), _context6.t1;
            case 18:
              _context6.t2 = i;
              if (!_context6.t2) {
                _context6.next = 24;
                break;
              }
              _context6.next = 22;
              return _this.sendError({
                id: e,
                topic: i,
                error: s
              });
            case 22:
              _context6.next = 24;
              return _this.client.proposal.delete(e, R("USER_DISCONNECTED"));
            case 24:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[2, 7], [11, 15]]);
      }));
      return function (_x5) {
        return _ref7.apply(this, arguments);
      };
    }(), _this.update = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(t) {
        var e, s, _U2, i, r, o, a, c, d;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this.isInitialized();
            case 2:
              _context7.prev = 2;
              _context7.next = 5;
              return _this.isValidUpdate(t);
            case 5:
              _context7.next = 10;
              break;
            case 7:
              _context7.prev = 7;
              _context7.t0 = _context7["catch"](2);
              throw _this.client.logger.error("update() -> isValidUpdate() failed"), _context7.t0;
            case 10:
              e = t.topic, s = t.namespaces, _U2 = U(), i = _U2.done, r = _U2.resolve, o = _U2.reject, a = k(), c = te().toString(), d = _this.client.session.get(e).namespaces;
              _this.events.once(u("session_update", a), function (_ref9) {
                var p = _ref9.error;
                p ? o(p) : r();
              });
              _context7.next = 14;
              return _this.client.session.update(e, {
                namespaces: s
              });
            case 14:
              _this.sendRequest({
                topic: e,
                method: "wc_sessionUpdate",
                params: {
                  namespaces: s
                },
                throwOnFailedPublish: !0,
                clientRpcId: a,
                relayRpcId: c
              }).catch(function (p) {
                _this.client.logger.error(p), _this.client.session.update(e, {
                  namespaces: d
                }), o(p);
              });
              return _context7.abrupt("return", {
                acknowledged: i
              });
            case 16:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[2, 7]]);
      }));
      return function (_x6) {
        return _ref8.apply(this, arguments);
      };
    }(), _this.extend = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(t) {
        var e, s, _U3, i, r, o;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this.isInitialized();
            case 2:
              _context8.prev = 2;
              _context8.next = 5;
              return _this.isValidExtend(t);
            case 5:
              _context8.next = 10;
              break;
            case 7:
              _context8.prev = 7;
              _context8.t0 = _context8["catch"](2);
              throw _this.client.logger.error("extend() -> isValidExtend() failed"), _context8.t0;
            case 10:
              e = t.topic, s = k(), _U3 = U(), i = _U3.done, r = _U3.resolve, o = _U3.reject;
              _this.events.once(u("session_extend", s), function (_ref11) {
                var a = _ref11.error;
                a ? o(a) : r();
              });
              _context8.next = 14;
              return _this.setExpiry(e, N(L));
            case 14:
              _this.sendRequest({
                topic: e,
                method: "wc_sessionExtend",
                params: {},
                clientRpcId: s,
                throwOnFailedPublish: !0
              }).catch(function (a) {
                o(a);
              });
              return _context8.abrupt("return", {
                acknowledged: i
              });
            case 16:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[2, 7]]);
      }));
      return function (_x7) {
        return _ref10.apply(this, arguments);
      };
    }(), _this.request = /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(t) {
        var e, s, i, _t$expiry, r, o, a, c, _U4, d, p, g;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this.isInitialized();
            case 2:
              _context11.prev = 2;
              _context11.next = 5;
              return _this.isValidRequest(t);
            case 5:
              _context11.next = 10;
              break;
            case 7:
              _context11.prev = 7;
              _context11.t0 = _context11["catch"](2);
              throw _this.client.logger.error("request() -> isValidRequest() failed"), _context11.t0;
            case 10:
              e = t.chainId, s = t.request, i = t.topic, _t$expiry = t.expiry, r = _t$expiry === void 0 ? q.wc_sessionRequest.req.ttl : _t$expiry, o = _this.client.session.get(i), a = k(), c = te().toString(), _U4 = U(r, "Request expired. Please try again."), d = _U4.done, p = _U4.resolve, g = _U4.reject;
              _this.events.once(u("session_request", a), function (_ref13) {
                var h = _ref13.error,
                  y = _ref13.result;
                h ? g(h) : p(y);
              });
              _context11.next = 14;
              return Promise.all([new Promise( /*#__PURE__*/function () {
                var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(h) {
                  return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.next = 2;
                        return _this.sendRequest({
                          clientRpcId: a,
                          relayRpcId: c,
                          topic: i,
                          method: "wc_sessionRequest",
                          params: {
                            request: F(m({}, s), {
                              expiryTimestamp: N(r)
                            }),
                            chainId: e
                          },
                          expiry: r,
                          throwOnFailedPublish: !0
                        }).catch(function (y) {
                          return g(y);
                        });
                      case 2:
                        _this.client.events.emit("session_request_sent", {
                          topic: i,
                          request: s,
                          chainId: e,
                          id: a
                        });
                        h();
                      case 4:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9);
                }));
                return function (_x9) {
                  return _ref14.apply(this, arguments);
                };
              }()), new Promise( /*#__PURE__*/function () {
                var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(h) {
                  var y, w;
                  return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        if ((y = o.sessionConfig) != null && y.disableDeepLink) {
                          _context10.next = 5;
                          break;
                        }
                        _context10.next = 3;
                        return pt(_this.client.core.storage, Re);
                      case 3:
                        w = _context10.sent;
                        dt({
                          id: a,
                          topic: i,
                          wcDeepLink: w
                        });
                      case 5:
                        h();
                      case 6:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee10);
                }));
                return function (_x10) {
                  return _ref15.apply(this, arguments);
                };
              }()), d()]).then(function (h) {
                return h[2];
              });
            case 14:
              return _context11.abrupt("return", _context11.sent);
            case 15:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[2, 7]]);
      }));
      return function (_x8) {
        return _ref12.apply(this, arguments);
      };
    }(), _this.respond = /*#__PURE__*/function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(t) {
        var e, s, i;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return _this.isInitialized();
            case 2:
              _context12.next = 4;
              return _this.isValidRespond(t);
            case 4:
              e = t.topic, s = t.response, i = s.id;
              if (!b(s)) {
                _context12.next = 10;
                break;
              }
              _context12.next = 8;
              return _this.sendResult({
                id: i,
                topic: e,
                result: s.result,
                throwOnFailedPublish: !0
              });
            case 8:
              _context12.next = 14;
              break;
            case 10:
              _context12.t0 = $(s);
              if (!_context12.t0) {
                _context12.next = 14;
                break;
              }
              _context12.next = 14;
              return _this.sendError({
                id: i,
                topic: e,
                error: s.error
              });
            case 14:
              _this.cleanupAfterResponse(t);
            case 15:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      return function (_x11) {
        return _ref16.apply(this, arguments);
      };
    }(), _this.ping = /*#__PURE__*/function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(t) {
        var e, s, i, _U5, r, o, a;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return _this.isInitialized();
            case 2:
              _context13.prev = 2;
              _context13.next = 5;
              return _this.isValidPing(t);
            case 5:
              _context13.next = 10;
              break;
            case 7:
              _context13.prev = 7;
              _context13.t0 = _context13["catch"](2);
              throw _this.client.logger.error("ping() -> isValidPing() failed"), _context13.t0;
            case 10:
              e = t.topic;
              if (!_this.client.session.keys.includes(e)) {
                _context13.next = 18;
                break;
              }
              s = k(), i = te().toString(), _U5 = U(), r = _U5.done, o = _U5.resolve, a = _U5.reject;
              _this.events.once(u("session_ping", s), function (_ref18) {
                var c = _ref18.error;
                c ? a(c) : o();
              });
              _context13.next = 16;
              return Promise.all([_this.sendRequest({
                topic: e,
                method: "wc_sessionPing",
                params: {},
                throwOnFailedPublish: !0,
                clientRpcId: s,
                relayRpcId: i
              }), r()]);
            case 16:
              _context13.next = 22;
              break;
            case 18:
              _context13.t1 = _this.client.core.pairing.pairings.keys.includes(e);
              if (!_context13.t1) {
                _context13.next = 22;
                break;
              }
              _context13.next = 22;
              return _this.client.core.pairing.ping({
                topic: e
              });
            case 22:
            case "end":
              return _context13.stop();
          }
        }, _callee13, null, [[2, 7]]);
      }));
      return function (_x12) {
        return _ref17.apply(this, arguments);
      };
    }(), _this.emit = /*#__PURE__*/function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(t) {
        var e, s, i, r;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return _this.isInitialized();
            case 2:
              _context14.next = 4;
              return _this.isValidEmit(t);
            case 4:
              e = t.topic, s = t.event, i = t.chainId, r = te().toString();
              _context14.next = 7;
              return _this.sendRequest({
                topic: e,
                method: "wc_sessionEvent",
                params: {
                  event: s,
                  chainId: i
                },
                throwOnFailedPublish: !0,
                relayRpcId: r
              });
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      return function (_x13) {
        return _ref19.apply(this, arguments);
      };
    }(), _this.disconnect = /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(t) {
        var e, _l2, s;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return _this.isInitialized();
            case 2:
              _context15.next = 4;
              return _this.isValidDisconnect(t);
            case 4:
              e = t.topic;
              if (!_this.client.session.keys.includes(e)) {
                _context15.next = 12;
                break;
              }
              _context15.next = 8;
              return _this.sendRequest({
                topic: e,
                method: "wc_sessionDelete",
                params: R("USER_DISCONNECTED"),
                throwOnFailedPublish: !0
              });
            case 8:
              _context15.next = 10;
              return _this.deleteSession({
                topic: e,
                emitEvent: !1
              });
            case 10:
              _context15.next = 19;
              break;
            case 12:
              if (!_this.client.core.pairing.pairings.keys.includes(e)) {
                _context15.next = 17;
                break;
              }
              _context15.next = 15;
              return _this.client.core.pairing.disconnect({
                topic: e
              });
            case 15:
              _context15.next = 19;
              break;
            case 17:
              _l2 = l("MISMATCHED_TOPIC", "Session or pairing topic not found: ".concat(e)), s = _l2.message;
              throw new Error(s);
            case 19:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
      return function (_x14) {
        return _ref20.apply(this, arguments);
      };
    }(), _this.find = function (t) {
      return _this.isInitialized(), _this.client.session.getAll().filter(function (e) {
        return ut(e, t);
      });
    }, _this.getPendingSessionRequests = function () {
      return _this.client.pendingRequest.getAll();
    }, _this.authenticate = /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(t) {
        var e, _t$statement, s, i, r, o, a, c, d, _t$methods, p, g, _yield$_this$client$c2, h, y, w, I, _ge, O, _, D, E, P, f, _U6, v, j, oe, B, ae, M, ce;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _this.isInitialized(), _this.isValidAuthenticate(t);
              e = t.chains;
              _t$statement = t.statement;
              s = _t$statement === void 0 ? "" : _t$statement;
              i = t.uri;
              r = t.domain;
              o = t.nonce;
              a = t.type;
              c = t.exp;
              d = t.nbf;
              _t$methods = t.methods;
              p = _t$methods === void 0 ? [] : _t$methods;
              g = _toConsumableArray(t.resources || []);
              _context18.next = 15;
              return _this.client.core.pairing.create({
                methods: ["wc_sessionAuthenticate"]
              });
            case 15:
              _yield$_this$client$c2 = _context18.sent;
              h = _yield$_this$client$c2.topic;
              y = _yield$_this$client$c2.uri;
              _this.client.logger.info({
                message: "Generated new pairing",
                pairing: {
                  topic: h,
                  uri: y
                }
              });
              _context18.next = 21;
              return _this.client.core.crypto.generateKeyPair();
            case 21:
              w = _context18.sent;
              I = ue(w);
              _context18.next = 25;
              return Promise.all([_this.client.auth.authKeys.set(J, {
                responseTopic: I,
                publicKey: w
              }), _this.client.auth.pairingTopics.set(I, {
                topic: I,
                pairingTopic: h
              })]);
            case 25:
              _context18.next = 27;
              return _this.client.core.relayer.subscribe(I);
            case 27:
              _this.client.logger.info("sending request to new pairing topic: ".concat(h));
              if (!(p.length > 0)) {
                _context18.next = 32;
                break;
              }
              _ge = ge(e[0]), O = _ge.namespace;
              _ = gt(O, "request", p);
              we(g) && (_ = wt(_, g.pop())), g.push(_);
            case 32:
              D = N(q.wc_sessionPropose.req.ttl), E = {
                authPayload: {
                  type: a !== null && a !== void 0 ? a : "caip122",
                  chains: e,
                  statement: s,
                  aud: i,
                  domain: r,
                  version: "1",
                  nonce: o,
                  iat: new Date().toISOString(),
                  exp: c,
                  nbf: d,
                  resources: g
                },
                requester: {
                  publicKey: w,
                  metadata: _this.client.metadata
                },
                expiryTimestamp: D
              }, P = {
                eip155: {
                  chains: e,
                  methods: _toConsumableArray(new Set(["personal_sign"].concat(_toConsumableArray(p)))),
                  events: ["chainChanged", "accountsChanged"]
                }
              }, f = {
                requiredNamespaces: {},
                optionalNamespaces: P,
                relays: [{
                  protocol: "irn"
                }],
                proposer: {
                  publicKey: w,
                  metadata: _this.client.metadata
                },
                expiryTimestamp: D
              }, _U6 = U(q.wc_sessionAuthenticate.req.ttl, "Request expired"), v = _U6.done, j = _U6.resolve, oe = _U6.reject, B = /*#__PURE__*/function () {
                var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref22) {
                  var O, _, Q;
                  return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) switch (_context16.prev = _context16.next) {
                      case 0:
                        O = _ref22.error, _ = _ref22.session;
                        if (!(_this.events.off(u("session_request", M), ae), O)) {
                          _context16.next = 5;
                          break;
                        }
                        oe(O);
                        _context16.next = 17;
                        break;
                      case 5:
                        if (!_) {
                          _context16.next = 17;
                          break;
                        }
                        _.self.publicKey = w;
                        _context16.next = 9;
                        return _this.client.session.set(_.topic, _);
                      case 9:
                        _context16.next = 11;
                        return _this.setExpiry(_.topic, _.expiry);
                      case 11:
                        _context16.t0 = h;
                        if (!_context16.t0) {
                          _context16.next = 15;
                          break;
                        }
                        _context16.next = 15;
                        return _this.client.core.pairing.updateMetadata({
                          topic: h,
                          metadata: _.peer.metadata
                        });
                      case 15:
                        Q = _this.client.session.get(_.topic);
                        j({
                          session: Q
                        });
                      case 17:
                      case "end":
                        return _context16.stop();
                    }
                  }, _callee16);
                }));
                return function B(_x16) {
                  return _ref23.apply(this, arguments);
                };
              }(), ae = /*#__PURE__*/function () {
                var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(O) {
                  var z, _O$result, _, Q, le, Ie, _iterator2, _step2, _z, he, pe, fe, Ze, de, et, _i, _fe, _de, W, Z;
                  return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) switch (_context17.prev = _context17.next) {
                      case 0:
                        if (!O.error) {
                          _context17.next = 3;
                          break;
                        }
                        z = R("WC_METHOD_UNSUPPORTED", "wc_sessionAuthenticate");
                        return _context17.abrupt("return", O.error.code === z.code ? void 0 : (_this.events.off(u("session_connect"), B), oe(O.error.message)));
                      case 3:
                        _this.events.off(u("session_connect"), B);
                        _O$result = O.result, _ = _O$result.cacaos, Q = _O$result.responder, le = [], Ie = [];
                        _iterator2 = _createForOfIteratorHelper(_);
                        _context17.prev = 6;
                        _iterator2.s();
                      case 8:
                        if ((_step2 = _iterator2.n()).done) {
                          _context17.next = 20;
                          break;
                        }
                        _z = _step2.value;
                        _context17.next = 12;
                        return Pe({
                          cacao: _z,
                          projectId: _this.client.core.projectId
                        });
                      case 12:
                        _context17.t0 = _context17.sent;
                        if (_context17.t0) {
                          _context17.next = 15;
                          break;
                        }
                        _this.client.logger.error(_z, "Signature verification failed"), oe(R("SESSION_SETTLEMENT_FAILED", "Signature verification failed"));
                      case 15:
                        he = _z.p, pe = we(he.resources), fe = [ve(he.iss)], Ze = Oe(he.iss);
                        if (pe) {
                          de = Te(pe), et = De(pe);
                          le.push.apply(le, _toConsumableArray(de)), fe.push.apply(fe, _toConsumableArray(et));
                        }
                        for (_i = 0, _fe = fe; _i < _fe.length; _i++) {
                          _de = _fe[_i];
                          Ie.push("".concat(_de, ":").concat(Ze));
                        }
                      case 18:
                        _context17.next = 8;
                        break;
                      case 20:
                        _context17.next = 25;
                        break;
                      case 22:
                        _context17.prev = 22;
                        _context17.t1 = _context17["catch"](6);
                        _iterator2.e(_context17.t1);
                      case 25:
                        _context17.prev = 25;
                        _iterator2.f();
                        return _context17.finish(25);
                      case 28:
                        _context17.next = 30;
                        return _this.client.core.crypto.generateSharedKey(w, Q.publicKey);
                      case 30:
                        W = _context17.sent;
                        _context17.t2 = le.length > 0;
                        if (!_context17.t2) {
                          _context17.next = 39;
                          break;
                        }
                        Z = {
                          topic: W,
                          acknowledged: !0,
                          self: {
                            publicKey: w,
                            metadata: _this.client.metadata
                          },
                          peer: Q,
                          controller: Q.publicKey,
                          expiry: N(L),
                          requiredNamespaces: {},
                          optionalNamespaces: {},
                          relay: {
                            protocol: "irn"
                          },
                          pairingTopic: h,
                          namespaces: xe(_toConsumableArray(new Set(le)), _toConsumableArray(new Set(Ie)))
                        };
                        _context17.next = 36;
                        return _this.client.core.relayer.subscribe(W);
                      case 36:
                        _context17.next = 38;
                        return _this.client.session.set(W, Z);
                      case 38:
                        Z = _this.client.session.get(W);
                      case 39:
                        j({
                          auths: _,
                          session: Z
                        });
                      case 40:
                      case "end":
                        return _context17.stop();
                    }
                  }, _callee17, null, [[6, 22, 25, 28]]);
                }));
                return function ae(_x17) {
                  return _ref24.apply(this, arguments);
                };
              }(), M = k(), ce = k();
              _this.events.once(u("session_connect"), B), _this.events.once(u("session_request", M), ae);
              _context18.prev = 34;
              _context18.next = 37;
              return Promise.all([_this.sendRequest({
                topic: h,
                method: "wc_sessionAuthenticate",
                params: E,
                expiry: t.expiry,
                throwOnFailedPublish: !0,
                clientRpcId: M
              }), _this.sendRequest({
                topic: h,
                method: "wc_sessionPropose",
                params: f,
                expiry: q.wc_sessionPropose.req.ttl,
                throwOnFailedPublish: !0,
                clientRpcId: ce
              })]);
            case 37:
              _context18.next = 42;
              break;
            case 39:
              _context18.prev = 39;
              _context18.t0 = _context18["catch"](34);
              throw _this.events.off(u("session_connect"), B), _this.events.off(u("session_request", M), ae), _context18.t0;
            case 42:
              _context18.next = 44;
              return _this.setProposal(ce, m({
                id: ce
              }, f));
            case 44:
              _context18.next = 46;
              return _this.client.auth.requests.set(M, {
                authPayload: E.authPayload,
                requester: E.requester,
                expiryTimestamp: D,
                id: M,
                pairingTopic: h,
                verifyContext: {}
              });
            case 46:
              return _context18.abrupt("return", {
                uri: y,
                response: v
              });
            case 47:
            case "end":
              return _context18.stop();
          }
        }, _callee18, null, [[34, 39]]);
      }));
      return function (_x15) {
        return _ref21.apply(this, arguments);
      };
    }(), _this.approveSessionAuthenticate = /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(t) {
        var e, s, i, r, o, a, c, d, p, _iterator3, _step3, y, P, w, I, D, E, _P, f, _i2, _D, _P2, g, h;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _this.isInitialized();
              e = t.id, s = t.auths, i = _this.getPendingAuthRequest(e);
              if (i) {
                _context19.next = 4;
                break;
              }
              throw new Error("Could not find pending auth request with id ".concat(e));
            case 4:
              r = i.requester.publicKey;
              _context19.next = 7;
              return _this.client.core.crypto.generateKeyPair();
            case 7:
              o = _context19.sent;
              a = ue(r);
              c = {
                type: be,
                receiverPublicKey: r,
                senderPublicKey: o
              };
              d = [];
              p = [];
              _iterator3 = _createForOfIteratorHelper(s);
              _context19.prev = 13;
              _iterator3.s();
            case 15:
              if ((_step3 = _iterator3.n()).done) {
                _context19.next = 29;
                break;
              }
              y = _step3.value;
              _context19.next = 19;
              return Pe({
                cacao: y,
                projectId: _this.client.core.projectId
              });
            case 19:
              if (_context19.sent) {
                _context19.next = 24;
                break;
              }
              P = R("SESSION_SETTLEMENT_FAILED", "Signature verification failed");
              _context19.next = 23;
              return _this.sendError({
                id: e,
                topic: a,
                error: P,
                encodeOpts: c
              });
            case 23:
              throw new Error(P.message);
            case 24:
              w = y.p, I = we(w.resources), D = [ve(w.iss)], E = Oe(w.iss);
              if (I) {
                _P = Te(I), f = De(I);
                d.push.apply(d, _toConsumableArray(_P)), D.push.apply(D, _toConsumableArray(f));
              }
              for (_i2 = 0, _D = D; _i2 < _D.length; _i2++) {
                _P2 = _D[_i2];
                p.push("".concat(_P2, ":").concat(E));
              }
            case 27:
              _context19.next = 15;
              break;
            case 29:
              _context19.next = 34;
              break;
            case 31:
              _context19.prev = 31;
              _context19.t0 = _context19["catch"](13);
              _iterator3.e(_context19.t0);
            case 34:
              _context19.prev = 34;
              _iterator3.f();
              return _context19.finish(34);
            case 37:
              _context19.next = 39;
              return _this.client.core.crypto.generateSharedKey(o, r);
            case 39:
              g = _context19.sent;
              _context19.t1 = (d === null || d === void 0 ? void 0 : d.length) > 0;
              if (!_context19.t1) {
                _context19.next = 47;
                break;
              }
              h = {
                topic: g,
                acknowledged: !0,
                self: {
                  publicKey: o,
                  metadata: _this.client.metadata
                },
                peer: {
                  publicKey: r,
                  metadata: i.requester.metadata
                },
                controller: r,
                expiry: N(L),
                authentication: s,
                requiredNamespaces: {},
                optionalNamespaces: {},
                relay: {
                  protocol: "irn"
                },
                pairingTopic: "",
                namespaces: xe(_toConsumableArray(new Set(d)), _toConsumableArray(new Set(p)))
              };
              _context19.next = 45;
              return _this.client.core.relayer.subscribe(g);
            case 45:
              _context19.next = 47;
              return _this.client.session.set(g, h);
            case 47:
              _context19.next = 49;
              return _this.sendResult({
                topic: a,
                id: e,
                result: {
                  cacaos: s,
                  responder: {
                    publicKey: o,
                    metadata: _this.client.metadata
                  }
                },
                encodeOpts: c,
                throwOnFailedPublish: !0
              });
            case 49:
              _context19.next = 51;
              return _this.client.auth.requests.delete(e, {
                message: "fullfilled",
                code: 0
              });
            case 51:
              _context19.next = 53;
              return _this.client.core.pairing.activate({
                topic: i.pairingTopic
              });
            case 53:
              return _context19.abrupt("return", {
                session: h
              });
            case 54:
            case "end":
              return _context19.stop();
          }
        }, _callee19, null, [[13, 31, 34, 37]]);
      }));
      return function (_x18) {
        return _ref25.apply(this, arguments);
      };
    }(), _this.rejectSessionAuthenticate = /*#__PURE__*/function () {
      var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(t) {
        var e, s, i, r, o, a, c;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return _this.isInitialized();
            case 2:
              e = t.id, s = t.reason, i = _this.getPendingAuthRequest(e);
              if (i) {
                _context20.next = 5;
                break;
              }
              throw new Error("Could not find pending auth request with id ".concat(e));
            case 5:
              r = i.requester.publicKey;
              _context20.next = 8;
              return _this.client.core.crypto.generateKeyPair();
            case 8:
              o = _context20.sent;
              a = ue(r);
              c = {
                type: be,
                receiverPublicKey: r,
                senderPublicKey: o
              };
              _context20.next = 13;
              return _this.sendError({
                id: e,
                topic: a,
                error: s,
                encodeOpts: c
              });
            case 13:
              _context20.next = 15;
              return _this.client.auth.requests.delete(e, {
                message: "rejected",
                code: 0
              });
            case 15:
              _context20.next = 17;
              return _this.client.proposal.delete(e, R("USER_DISCONNECTED"));
            case 17:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      return function (_x19) {
        return _ref26.apply(this, arguments);
      };
    }(), _this.formatAuthMessage = function (t) {
      _this.isInitialized();
      var e = t.request,
        s = t.iss;
      return yt(e, s);
    }, _this.cleanupDuplicatePairings = /*#__PURE__*/function () {
      var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(t) {
        var e, s;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              if (!t.pairingTopic) {
                _context21.next = 14;
                break;
              }
              _context21.prev = 1;
              e = _this.client.core.pairing.pairings.get(t.pairingTopic), s = _this.client.core.pairing.pairings.getAll().filter(function (i) {
                var r, o;
                return ((r = i.peerMetadata) == null ? void 0 : r.url) && ((o = i.peerMetadata) == null ? void 0 : o.url) === t.peer.metadata.url && i.topic && i.topic !== e.topic;
              });
              if (!(s.length === 0)) {
                _context21.next = 5;
                break;
              }
              return _context21.abrupt("return");
            case 5:
              _this.client.logger.info("Cleaning up ".concat(s.length, " duplicate pairing(s)"));
              _context21.next = 8;
              return Promise.all(s.map(function (i) {
                return _this.client.core.pairing.disconnect({
                  topic: i.topic
                });
              }));
            case 8:
              _this.client.logger.info("Duplicate pairings clean up finished");
              _context21.next = 14;
              break;
            case 11:
              _context21.prev = 11;
              _context21.t0 = _context21["catch"](1);
              _this.client.logger.error(_context21.t0);
            case 14:
            case "end":
              return _context21.stop();
          }
        }, _callee21, null, [[1, 11]]);
      }));
      return function (_x20) {
        return _ref27.apply(this, arguments);
      };
    }(), _this.deleteSession = /*#__PURE__*/function () {
      var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(t) {
        var e, _t$expirerHasDeleted, s, _t$emitEvent, i, _t$id, r, _this$client$session$, o;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              e = t.topic, _t$expirerHasDeleted = t.expirerHasDeleted, s = _t$expirerHasDeleted === void 0 ? !1 : _t$expirerHasDeleted, _t$emitEvent = t.emitEvent, i = _t$emitEvent === void 0 ? !0 : _t$emitEvent, _t$id = t.id, r = _t$id === void 0 ? 0 : _t$id, _this$client$session$ = _this.client.session.get(e), o = _this$client$session$.self;
              _context22.next = 3;
              return _this.client.core.relayer.unsubscribe(e);
            case 3:
              _context22.next = 5;
              return _this.client.session.delete(e, R("USER_DISCONNECTED"));
            case 5:
              _this.addToRecentlyDeleted(e, "session");
              _context22.t0 = _this.client.core.crypto.keychain.has(o.publicKey);
              if (!_context22.t0) {
                _context22.next = 10;
                break;
              }
              _context22.next = 10;
              return _this.client.core.crypto.deleteKeyPair(o.publicKey);
            case 10:
              _context22.t1 = _this.client.core.crypto.keychain.has(e);
              if (!_context22.t1) {
                _context22.next = 14;
                break;
              }
              _context22.next = 14;
              return _this.client.core.crypto.deleteSymKey(e);
            case 14:
              s || _this.client.core.expirer.del(e);
              _this.client.core.storage.removeItem(Re).catch(function (a) {
                return _this.client.logger.warn(a);
              });
              _this.getPendingSessionRequests().forEach(function (a) {
                a.topic === e && _this.deletePendingSessionRequest(a.id, R("USER_DISCONNECTED"));
              });
              i && _this.client.events.emit("session_delete", {
                id: r,
                topic: e
              });
            case 18:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }));
      return function (_x21) {
        return _ref28.apply(this, arguments);
      };
    }(), _this.deleteProposal = /*#__PURE__*/function () {
      var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(t, e) {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return Promise.all([_this.client.proposal.delete(t, R("USER_DISCONNECTED")), e ? Promise.resolve() : _this.client.core.expirer.del(t)]);
            case 2:
              _this.addToRecentlyDeleted(t, "proposal");
            case 3:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }));
      return function (_x22, _x23) {
        return _ref29.apply(this, arguments);
      };
    }(), _this.deletePendingSessionRequest = /*#__PURE__*/function () {
      var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(t, e) {
        var s,
          _args24 = arguments;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              s = _args24.length > 2 && _args24[2] !== undefined ? _args24[2] : !1;
              _context24.next = 3;
              return Promise.all([_this.client.pendingRequest.delete(t, e), s ? Promise.resolve() : _this.client.core.expirer.del(t)]);
            case 3:
              _this.addToRecentlyDeleted(t, "request");
              _this.sessionRequestQueue.queue = _this.sessionRequestQueue.queue.filter(function (i) {
                return i.id !== t;
              });
              s && (_this.sessionRequestQueue.state = A.idle, _this.client.events.emit("session_request_expire", {
                id: t
              }));
            case 6:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      }));
      return function (_x24, _x25) {
        return _ref30.apply(this, arguments);
      };
    }(), _this.setExpiry = /*#__PURE__*/function () {
      var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(t, e) {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _context25.t0 = _this.client.session.keys.includes(t);
              if (!_context25.t0) {
                _context25.next = 4;
                break;
              }
              _context25.next = 4;
              return _this.client.session.update(t, {
                expiry: e
              });
            case 4:
              _this.client.core.expirer.set(t, e);
            case 5:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }));
      return function (_x26, _x27) {
        return _ref31.apply(this, arguments);
      };
    }(), _this.setProposal = /*#__PURE__*/function () {
      var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(t, e) {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return _this.client.proposal.set(t, e);
            case 2:
              _this.client.core.expirer.set(t, N(q.wc_sessionPropose.req.ttl));
            case 3:
            case "end":
              return _context26.stop();
          }
        }, _callee26);
      }));
      return function (_x28, _x29) {
        return _ref32.apply(this, arguments);
      };
    }(), _this.setPendingSessionRequest = /*#__PURE__*/function () {
      var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(t) {
        var e, s, i, r, o;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              e = t.id, s = t.topic, i = t.params, r = t.verifyContext, o = i.request.expiryTimestamp || N(q.wc_sessionRequest.req.ttl);
              _context27.next = 3;
              return _this.client.pendingRequest.set(e, {
                id: e,
                topic: s,
                params: i,
                verifyContext: r
              });
            case 3:
              o && _this.client.core.expirer.set(e, o);
            case 4:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      }));
      return function (_x30) {
        return _ref33.apply(this, arguments);
      };
    }(), _this.sendRequest = /*#__PURE__*/function () {
      var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(t) {
        var e, s, i, r, o, a, c, d, h, p, g;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              e = t.topic, s = t.method, i = t.params, r = t.expiry, o = t.relayRpcId, a = t.clientRpcId, c = t.throwOnFailedPublish, d = me(s, i, a);
              if (mt() && je.includes(s)) {
                h = ee(JSON.stringify(d));
                _this.client.core.verify.register({
                  attestationId: h
                });
              }
              _context28.prev = 2;
              _context28.next = 5;
              return _this.client.core.crypto.encode(e, d);
            case 5:
              p = _context28.sent;
              _context28.next = 14;
              break;
            case 8:
              _context28.prev = 8;
              _context28.t0 = _context28["catch"](2);
              _context28.next = 12;
              return _this.cleanup();
            case 12:
              _this.client.logger.error("sendRequest() -> core.crypto.encode() for topic ".concat(e, " failed"));
              throw _context28.t0;
            case 14:
              g = q[s].req;
              r && (g.ttl = r);
              o && (g.id = o);
              _this.client.core.history.set(e, d);
              if (!c) {
                _context28.next = 24;
                break;
              }
              g.internal = F(m({}, g.internal), {
                throwOnFailedPublish: !0
              });
              _context28.next = 22;
              return _this.client.core.relayer.publish(e, p, g);
            case 22:
              _context28.next = 25;
              break;
            case 24:
              _this.client.core.relayer.publish(e, p, g).catch(function (h) {
                return _this.client.logger.error(h);
              });
            case 25:
              return _context28.abrupt("return", d.id);
            case 26:
            case "end":
              return _context28.stop();
          }
        }, _callee28, null, [[2, 8]]);
      }));
      return function (_x31) {
        return _ref34.apply(this, arguments);
      };
    }(), _this.sendResult = /*#__PURE__*/function () {
      var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(t) {
        var e, s, i, r, o, a, c, d, p;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              e = t.id, s = t.topic, i = t.result, r = t.throwOnFailedPublish, o = t.encodeOpts, a = $t(e, i);
              _context29.prev = 1;
              _context29.next = 4;
              return _this.client.core.crypto.encode(s, a, o);
            case 4:
              c = _context29.sent;
              _context29.next = 13;
              break;
            case 7:
              _context29.prev = 7;
              _context29.t0 = _context29["catch"](1);
              _context29.next = 11;
              return _this.cleanup();
            case 11:
              _this.client.logger.error("sendResult() -> core.crypto.encode() for topic ".concat(s, " failed"));
              throw _context29.t0;
            case 13:
              _context29.prev = 13;
              _context29.next = 16;
              return _this.client.core.history.get(s, e);
            case 16:
              d = _context29.sent;
              _context29.next = 22;
              break;
            case 19:
              _context29.prev = 19;
              _context29.t1 = _context29["catch"](13);
              throw _this.client.logger.error("sendResult() -> history.get(".concat(s, ", ").concat(e, ") failed")), _context29.t1;
            case 22:
              p = q[d.request.method].res;
              if (!r) {
                _context29.next = 29;
                break;
              }
              p.internal = F(m({}, p.internal), {
                throwOnFailedPublish: !0
              });
              _context29.next = 27;
              return _this.client.core.relayer.publish(s, c, p);
            case 27:
              _context29.next = 30;
              break;
            case 29:
              _this.client.core.relayer.publish(s, c, p).catch(function (g) {
                return _this.client.logger.error(g);
              });
            case 30:
              _context29.next = 32;
              return _this.client.core.history.resolve(a);
            case 32:
            case "end":
              return _context29.stop();
          }
        }, _callee29, null, [[1, 7], [13, 19]]);
      }));
      return function (_x32) {
        return _ref35.apply(this, arguments);
      };
    }(), _this.sendError = /*#__PURE__*/function () {
      var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(t) {
        var e, s, i, r, o, a, c, d;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              e = t.id, s = t.topic, i = t.error, r = t.encodeOpts, o = Lt(e, i);
              _context30.prev = 1;
              _context30.next = 4;
              return _this.client.core.crypto.encode(s, o, r);
            case 4:
              a = _context30.sent;
              _context30.next = 13;
              break;
            case 7:
              _context30.prev = 7;
              _context30.t0 = _context30["catch"](1);
              _context30.next = 11;
              return _this.cleanup();
            case 11:
              _this.client.logger.error("sendError() -> core.crypto.encode() for topic ".concat(s, " failed"));
              throw _context30.t0;
            case 13:
              _context30.prev = 13;
              _context30.next = 16;
              return _this.client.core.history.get(s, e);
            case 16:
              c = _context30.sent;
              _context30.next = 22;
              break;
            case 19:
              _context30.prev = 19;
              _context30.t1 = _context30["catch"](13);
              throw _this.client.logger.error("sendError() -> history.get(".concat(s, ", ").concat(e, ") failed")), _context30.t1;
            case 22:
              d = q[c.request.method].res;
              _this.client.core.relayer.publish(s, a, d);
              _context30.next = 26;
              return _this.client.core.history.resolve(o);
            case 26:
            case "end":
              return _context30.stop();
          }
        }, _callee30, null, [[1, 7], [13, 19]]);
      }));
      return function (_x33) {
        return _ref36.apply(this, arguments);
      };
    }(), _this.cleanup = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
      var t, e;
      return _regeneratorRuntime.wrap(function _callee31$(_context31) {
        while (1) switch (_context31.prev = _context31.next) {
          case 0:
            t = [], e = [];
            _this.client.session.getAll().forEach(function (s) {
              var i = !1;
              G(s.expiry) && (i = !0), _this.client.core.crypto.keychain.has(s.topic) || (i = !0), i && t.push(s.topic);
            });
            _this.client.proposal.getAll().forEach(function (s) {
              G(s.expiryTimestamp) && e.push(s.id);
            });
            _context31.next = 5;
            return Promise.all([].concat(_toConsumableArray(t.map(function (s) {
              return _this.deleteSession({
                topic: s
              });
            })), _toConsumableArray(e.map(function (s) {
              return _this.deleteProposal(s);
            }))));
          case 5:
          case "end":
            return _context31.stop();
        }
      }, _callee31);
    })), _this.onRelayEventRequest = /*#__PURE__*/function () {
      var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(t) {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _this.requestQueue.queue.push(t);
              _context32.next = 3;
              return _this.processRequestsQueue();
            case 3:
            case "end":
              return _context32.stop();
          }
        }, _callee32);
      }));
      return function (_x34) {
        return _ref38.apply(this, arguments);
      };
    }(), _this.processRequestsQueue = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
      var t;
      return _regeneratorRuntime.wrap(function _callee33$(_context33) {
        while (1) switch (_context33.prev = _context33.next) {
          case 0:
            if (!(_this.requestQueue.state === A.active)) {
              _context33.next = 3;
              break;
            }
            _this.client.logger.info("Request queue already active, skipping...");
            return _context33.abrupt("return");
          case 3:
            _this.client.logger.info("Request queue starting with ".concat(_this.requestQueue.queue.length, " requests"));
          case 4:
            if (!(_this.requestQueue.queue.length > 0)) {
              _context33.next = 19;
              break;
            }
            _this.requestQueue.state = A.active;
            t = _this.requestQueue.queue.shift();
            if (!t) {
              _context33.next = 17;
              break;
            }
            _context33.prev = 8;
            _this.processRequest(t);
            _context33.next = 12;
            return new Promise(function (e) {
              return setTimeout(e, 300);
            });
          case 12:
            _context33.next = 17;
            break;
          case 14:
            _context33.prev = 14;
            _context33.t0 = _context33["catch"](8);
            _this.client.logger.warn(_context33.t0);
          case 17:
            _context33.next = 4;
            break;
          case 19:
            _this.requestQueue.state = A.idle;
          case 20:
          case "end":
            return _context33.stop();
        }
      }, _callee33, null, [[8, 14]]);
    })), _this.processRequest = function (t) {
      var e = t.topic,
        s = t.payload,
        i = s.method;
      if (!_this.shouldIgnorePairingRequest({
        topic: e,
        requestMethod: i
      })) switch (i) {
        case "wc_sessionPropose":
          return _this.onSessionProposeRequest(e, s);
        case "wc_sessionSettle":
          return _this.onSessionSettleRequest(e, s);
        case "wc_sessionUpdate":
          return _this.onSessionUpdateRequest(e, s);
        case "wc_sessionExtend":
          return _this.onSessionExtendRequest(e, s);
        case "wc_sessionPing":
          return _this.onSessionPingRequest(e, s);
        case "wc_sessionDelete":
          return _this.onSessionDeleteRequest(e, s);
        case "wc_sessionRequest":
          return _this.onSessionRequest(e, s);
        case "wc_sessionEvent":
          return _this.onSessionEventRequest(e, s);
        case "wc_sessionAuthenticate":
          return _this.onSessionAuthenticateRequest(e, s);
        default:
          return _this.client.logger.info("Unsupported request method ".concat(i));
      }
    }, _this.onRelayEventResponse = /*#__PURE__*/function () {
      var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(t) {
        var e, s, i;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              e = t.topic;
              s = t.payload;
              _context34.next = 4;
              return _this.client.core.history.get(e, s.id);
            case 4:
              i = _context34.sent.request.method;
              _context34.t0 = i;
              _context34.next = _context34.t0 === "wc_sessionPropose" ? 8 : _context34.t0 === "wc_sessionSettle" ? 9 : _context34.t0 === "wc_sessionUpdate" ? 10 : _context34.t0 === "wc_sessionExtend" ? 11 : _context34.t0 === "wc_sessionPing" ? 12 : _context34.t0 === "wc_sessionRequest" ? 13 : _context34.t0 === "wc_sessionAuthenticate" ? 14 : 15;
              break;
            case 8:
              return _context34.abrupt("return", _this.onSessionProposeResponse(e, s));
            case 9:
              return _context34.abrupt("return", _this.onSessionSettleResponse(e, s));
            case 10:
              return _context34.abrupt("return", _this.onSessionUpdateResponse(e, s));
            case 11:
              return _context34.abrupt("return", _this.onSessionExtendResponse(e, s));
            case 12:
              return _context34.abrupt("return", _this.onSessionPingResponse(e, s));
            case 13:
              return _context34.abrupt("return", _this.onSessionRequestResponse(e, s));
            case 14:
              return _context34.abrupt("return", _this.onSessionAuthenticateResponse(e, s));
            case 15:
              return _context34.abrupt("return", _this.client.logger.info("Unsupported response method ".concat(i)));
            case 16:
            case "end":
              return _context34.stop();
          }
        }, _callee34);
      }));
      return function (_x35) {
        return _ref40.apply(this, arguments);
      };
    }(), _this.onRelayEventUnknownPayload = function (t) {
      var e = t.topic,
        _l3 = l("MISSING_OR_INVALID", "Decoded payload on topic ".concat(e, " is not identifiable as a JSON-RPC request or a response.")),
        s = _l3.message;
      throw new Error(s);
    }, _this.shouldIgnorePairingRequest = function (t) {
      var e = t.topic,
        s = t.requestMethod,
        i = _this.expectedPairingMethodMap.get(e);
      return !i || i.includes(s) ? !1 : !!(i.includes("wc_sessionAuthenticate") && _this.client.events.listenerCount("session_authenticate") > 0);
    }, _this.onSessionProposeRequest = /*#__PURE__*/function () {
      var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(t, e) {
        var s, i, r, o, a, c;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              s = e.params, i = e.id;
              _context35.prev = 1;
              _this.isValidConnect(m({}, e.params));
              r = s.expiryTimestamp || N(q.wc_sessionPropose.req.ttl), o = m({
                id: i,
                pairingTopic: t,
                expiryTimestamp: r
              }, s);
              _context35.next = 6;
              return _this.setProposal(i, o);
            case 6:
              a = ee(JSON.stringify(e));
              _context35.next = 9;
              return _this.getVerifyContext(a, o.proposer.metadata);
            case 9:
              c = _context35.sent;
              _this.client.events.emit("session_proposal", {
                id: i,
                params: o,
                verifyContext: c
              });
              _context35.next = 18;
              break;
            case 13:
              _context35.prev = 13;
              _context35.t0 = _context35["catch"](1);
              _context35.next = 17;
              return _this.sendError({
                id: i,
                topic: t,
                error: _context35.t0
              });
            case 17:
              _this.client.logger.error(_context35.t0);
            case 18:
            case "end":
              return _context35.stop();
          }
        }, _callee35, null, [[1, 13]]);
      }));
      return function (_x36, _x37) {
        return _ref41.apply(this, arguments);
      };
    }(), _this.onSessionProposeResponse = /*#__PURE__*/function () {
      var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(t, e) {
        var s, i, r, o, a, c, d, _i3;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              s = e.id;
              if (!b(e)) {
                _context36.next = 22;
                break;
              }
              i = e.result;
              _this.client.logger.trace({
                type: "method",
                method: "onSessionProposeResponse",
                result: i
              });
              r = _this.client.proposal.get(s);
              _this.client.logger.trace({
                type: "method",
                method: "onSessionProposeResponse",
                proposal: r
              });
              o = r.proposer.publicKey;
              _this.client.logger.trace({
                type: "method",
                method: "onSessionProposeResponse",
                selfPublicKey: o
              });
              a = i.responderPublicKey;
              _this.client.logger.trace({
                type: "method",
                method: "onSessionProposeResponse",
                peerPublicKey: a
              });
              _context36.next = 12;
              return _this.client.core.crypto.generateSharedKey(o, a);
            case 12:
              c = _context36.sent;
              _this.client.logger.trace({
                type: "method",
                method: "onSessionProposeResponse",
                sessionTopic: c
              });
              _context36.next = 16;
              return _this.client.core.relayer.subscribe(c);
            case 16:
              d = _context36.sent;
              _this.client.logger.trace({
                type: "method",
                method: "onSessionProposeResponse",
                subscriptionId: d
              });
              _context36.next = 20;
              return _this.client.core.pairing.activate({
                topic: t
              });
            case 20:
              _context36.next = 29;
              break;
            case 22:
              if (!$(e)) {
                _context36.next = 29;
                break;
              }
              _context36.next = 25;
              return _this.client.proposal.delete(s, R("USER_DISCONNECTED"));
            case 25:
              _i3 = u("session_connect");
              if (!(_this.events.listenerCount(_i3) === 0)) {
                _context36.next = 28;
                break;
              }
              throw new Error("emitting ".concat(_i3, " without any listeners, 954"));
            case 28:
              _this.events.emit(u("session_connect"), {
                error: e.error
              });
            case 29:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      }));
      return function (_x38, _x39) {
        return _ref42.apply(this, arguments);
      };
    }(), _this.onSessionSettleRequest = /*#__PURE__*/function () {
      var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(t, e) {
        var s, i, _e$params, r, o, a, c, d, p, g, h, y;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              s = e.id, i = e.params;
              _context37.prev = 1;
              _this.isValidSessionSettleRequest(i);
              _e$params = e.params, r = _e$params.relay, o = _e$params.controller, a = _e$params.expiry, c = _e$params.namespaces, d = _e$params.sessionProperties, p = _e$params.pairingTopic, g = _e$params.sessionConfig, h = m(m({
                topic: t,
                relay: r,
                expiry: a,
                namespaces: c,
                acknowledged: !0,
                pairingTopic: p,
                requiredNamespaces: {},
                optionalNamespaces: {},
                controller: o.publicKey,
                self: {
                  publicKey: "",
                  metadata: _this.client.metadata
                },
                peer: {
                  publicKey: o.publicKey,
                  metadata: o.metadata
                }
              }, d && {
                sessionProperties: d
              }), g && {
                sessionConfig: g
              });
              _context37.next = 6;
              return _this.sendResult({
                id: e.id,
                topic: t,
                result: !0,
                throwOnFailedPublish: !0
              });
            case 6:
              y = u("session_connect");
              if (!(_this.events.listenerCount(y) === 0)) {
                _context37.next = 9;
                break;
              }
              throw new Error("emitting ".concat(y, " without any listeners 997"));
            case 9:
              _this.events.emit(u("session_connect"), {
                session: h
              }), _this.cleanupDuplicatePairings(h);
              _context37.next = 17;
              break;
            case 12:
              _context37.prev = 12;
              _context37.t0 = _context37["catch"](1);
              _context37.next = 16;
              return _this.sendError({
                id: s,
                topic: t,
                error: _context37.t0
              });
            case 16:
              _this.client.logger.error(_context37.t0);
            case 17:
            case "end":
              return _context37.stop();
          }
        }, _callee37, null, [[1, 12]]);
      }));
      return function (_x40, _x41) {
        return _ref43.apply(this, arguments);
      };
    }(), _this.onSessionSettleResponse = /*#__PURE__*/function () {
      var _ref44 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(t, e) {
        var s;
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              s = e.id;
              if (!b(e)) {
                _context38.next = 7;
                break;
              }
              _context38.next = 4;
              return _this.client.session.update(t, {
                acknowledged: !0
              });
            case 4:
              _this.events.emit(u("session_approve", s), {});
              _context38.next = 12;
              break;
            case 7:
              _context38.t0 = $(e);
              if (!_context38.t0) {
                _context38.next = 12;
                break;
              }
              _context38.next = 11;
              return _this.client.session.delete(t, R("USER_DISCONNECTED"));
            case 11:
              _this.events.emit(u("session_approve", s), {
                error: e.error
              });
            case 12:
            case "end":
              return _context38.stop();
          }
        }, _callee38);
      }));
      return function (_x42, _x43) {
        return _ref44.apply(this, arguments);
      };
    }(), _this.onSessionUpdateRequest = /*#__PURE__*/function () {
      var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(t, e) {
        var s, i, r, o;
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              s = e.params, i = e.id;
              _context39.prev = 1;
              r = "".concat(t, "_session_update"), o = H.get(r);
              if (!(o && _this.isRequestOutOfSync(o, i))) {
                _context39.next = 6;
                break;
              }
              _this.client.logger.info("Discarding out of sync request - ".concat(i)), _this.sendError({
                id: i,
                topic: t,
                error: R("INVALID_UPDATE_REQUEST")
              });
              return _context39.abrupt("return");
            case 6:
              _this.isValidUpdate(m({
                topic: t
              }, s));
              _context39.prev = 7;
              H.set(r, i);
              _context39.next = 11;
              return _this.client.session.update(t, {
                namespaces: s.namespaces
              });
            case 11:
              _context39.next = 13;
              return _this.sendResult({
                id: i,
                topic: t,
                result: !0,
                throwOnFailedPublish: !0
              });
            case 13:
              _context39.next = 18;
              break;
            case 15:
              _context39.prev = 15;
              _context39.t0 = _context39["catch"](7);
              throw H.delete(r), _context39.t0;
            case 18:
              _this.client.events.emit("session_update", {
                id: i,
                topic: t,
                params: s
              });
              _context39.next = 26;
              break;
            case 21:
              _context39.prev = 21;
              _context39.t1 = _context39["catch"](1);
              _context39.next = 25;
              return _this.sendError({
                id: i,
                topic: t,
                error: _context39.t1
              });
            case 25:
              _this.client.logger.error(_context39.t1);
            case 26:
            case "end":
              return _context39.stop();
          }
        }, _callee39, null, [[1, 21], [7, 15]]);
      }));
      return function (_x44, _x45) {
        return _ref45.apply(this, arguments);
      };
    }(), _this.isRequestOutOfSync = function (t, e) {
      return parseInt(e.toString().slice(0, -3)) <= parseInt(t.toString().slice(0, -3));
    }, _this.onSessionUpdateResponse = function (t, e) {
      var s = e.id,
        i = u("session_update", s);
      if (_this.events.listenerCount(i) === 0) throw new Error("emitting ".concat(i, " without any listeners"));
      b(e) ? _this.events.emit(u("session_update", s), {}) : $(e) && _this.events.emit(u("session_update", s), {
        error: e.error
      });
    }, _this.onSessionExtendRequest = /*#__PURE__*/function () {
      var _ref46 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(t, e) {
        var s;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              s = e.id;
              _context40.prev = 1;
              _this.isValidExtend({
                topic: t
              });
              _context40.next = 5;
              return _this.setExpiry(t, N(L));
            case 5:
              _context40.next = 7;
              return _this.sendResult({
                id: s,
                topic: t,
                result: !0,
                throwOnFailedPublish: !0
              });
            case 7:
              _this.client.events.emit("session_extend", {
                id: s,
                topic: t
              });
              _context40.next = 15;
              break;
            case 10:
              _context40.prev = 10;
              _context40.t0 = _context40["catch"](1);
              _context40.next = 14;
              return _this.sendError({
                id: s,
                topic: t,
                error: _context40.t0
              });
            case 14:
              _this.client.logger.error(_context40.t0);
            case 15:
            case "end":
              return _context40.stop();
          }
        }, _callee40, null, [[1, 10]]);
      }));
      return function (_x46, _x47) {
        return _ref46.apply(this, arguments);
      };
    }(), _this.onSessionExtendResponse = function (t, e) {
      var s = e.id,
        i = u("session_extend", s);
      if (_this.events.listenerCount(i) === 0) throw new Error("emitting ".concat(i, " without any listeners"));
      b(e) ? _this.events.emit(u("session_extend", s), {}) : $(e) && _this.events.emit(u("session_extend", s), {
        error: e.error
      });
    }, _this.onSessionPingRequest = /*#__PURE__*/function () {
      var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(t, e) {
        var s;
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              s = e.id;
              _context41.prev = 1;
              _this.isValidPing({
                topic: t
              });
              _context41.next = 5;
              return _this.sendResult({
                id: s,
                topic: t,
                result: !0,
                throwOnFailedPublish: !0
              });
            case 5:
              _this.client.events.emit("session_ping", {
                id: s,
                topic: t
              });
              _context41.next = 13;
              break;
            case 8:
              _context41.prev = 8;
              _context41.t0 = _context41["catch"](1);
              _context41.next = 12;
              return _this.sendError({
                id: s,
                topic: t,
                error: _context41.t0
              });
            case 12:
              _this.client.logger.error(_context41.t0);
            case 13:
            case "end":
              return _context41.stop();
          }
        }, _callee41, null, [[1, 8]]);
      }));
      return function (_x48, _x49) {
        return _ref47.apply(this, arguments);
      };
    }(), _this.onSessionPingResponse = function (t, e) {
      var s = e.id,
        i = u("session_ping", s);
      if (_this.events.listenerCount(i) === 0) throw new Error("emitting ".concat(i, " without any listeners"));
      setTimeout(function () {
        b(e) ? _this.events.emit(u("session_ping", s), {}) : $(e) && _this.events.emit(u("session_ping", s), {
          error: e.error
        });
      }, 500);
    }, _this.onSessionDeleteRequest = /*#__PURE__*/function () {
      var _ref48 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(t, e) {
        var s;
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              s = e.id;
              _context43.prev = 1;
              _this.isValidDisconnect({
                topic: t,
                reason: e.params
              });
              _context43.next = 5;
              return Promise.all([new Promise(function (i) {
                _this.client.core.relayer.once(qe.publish, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42() {
                  return _regeneratorRuntime.wrap(function _callee42$(_context42) {
                    while (1) switch (_context42.prev = _context42.next) {
                      case 0:
                        _context42.t0 = i;
                        _context42.next = 3;
                        return _this.deleteSession({
                          topic: t,
                          id: s
                        });
                      case 3:
                        _context42.t1 = _context42.sent;
                        (0, _context42.t0)(_context42.t1);
                      case 5:
                      case "end":
                        return _context42.stop();
                    }
                  }, _callee42);
                })));
              }), _this.sendResult({
                id: s,
                topic: t,
                result: !0,
                throwOnFailedPublish: !0
              }), _this.cleanupPendingSentRequestsForTopic({
                topic: t,
                error: R("USER_DISCONNECTED")
              })]);
            case 5:
              _context43.next = 10;
              break;
            case 7:
              _context43.prev = 7;
              _context43.t0 = _context43["catch"](1);
              _this.client.logger.error(_context43.t0);
            case 10:
            case "end":
              return _context43.stop();
          }
        }, _callee43, null, [[1, 7]]);
      }));
      return function (_x50, _x51) {
        return _ref48.apply(this, arguments);
      };
    }(), _this.onSessionRequest = /*#__PURE__*/function () {
      var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(t, e) {
        var s, i, r, o, a, c;
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              s = e.id, i = e.params;
              _context44.prev = 1;
              _context44.next = 4;
              return _this.isValidRequest(m({
                topic: t
              }, i));
            case 4:
              r = ee(JSON.stringify(me("wc_sessionRequest", i, s)));
              o = _this.client.session.get(t);
              _context44.next = 8;
              return _this.getVerifyContext(r, o.peer.metadata);
            case 8:
              a = _context44.sent;
              c = {
                id: s,
                topic: t,
                params: i,
                verifyContext: a
              };
              _context44.next = 12;
              return _this.setPendingSessionRequest(c);
            case 12:
              _this.addSessionRequestToSessionRequestQueue(c);
              _this.processSessionRequestQueue();
              _context44.next = 21;
              break;
            case 16:
              _context44.prev = 16;
              _context44.t0 = _context44["catch"](1);
              _context44.next = 20;
              return _this.sendError({
                id: s,
                topic: t,
                error: _context44.t0
              });
            case 20:
              _this.client.logger.error(_context44.t0);
            case 21:
            case "end":
              return _context44.stop();
          }
        }, _callee44, null, [[1, 16]]);
      }));
      return function (_x52, _x53) {
        return _ref50.apply(this, arguments);
      };
    }(), _this.onSessionRequestResponse = function (t, e) {
      var s = e.id,
        i = u("session_request", s);
      if (_this.events.listenerCount(i) === 0) throw new Error("emitting ".concat(i, " without any listeners"));
      b(e) ? _this.events.emit(u("session_request", s), {
        result: e.result
      }) : $(e) && _this.events.emit(u("session_request", s), {
        error: e.error
      });
    }, _this.onSessionEventRequest = /*#__PURE__*/function () {
      var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(t, e) {
        var s, i, r, o;
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              s = e.id, i = e.params;
              _context45.prev = 1;
              r = "".concat(t, "_session_event_").concat(i.event.name), o = H.get(r);
              if (!(o && _this.isRequestOutOfSync(o, s))) {
                _context45.next = 6;
                break;
              }
              _this.client.logger.info("Discarding out of sync request - ".concat(s));
              return _context45.abrupt("return");
            case 6:
              _this.isValidEmit(m({
                topic: t
              }, i)), _this.client.events.emit("session_event", {
                id: s,
                topic: t,
                params: i
              }), H.set(r, s);
              _context45.next = 14;
              break;
            case 9:
              _context45.prev = 9;
              _context45.t0 = _context45["catch"](1);
              _context45.next = 13;
              return _this.sendError({
                id: s,
                topic: t,
                error: _context45.t0
              });
            case 13:
              _this.client.logger.error(_context45.t0);
            case 14:
            case "end":
              return _context45.stop();
          }
        }, _callee45, null, [[1, 9]]);
      }));
      return function (_x54, _x55) {
        return _ref51.apply(this, arguments);
      };
    }(), _this.onSessionAuthenticateResponse = function (t, e) {
      var s = e.id;
      _this.client.logger.trace({
        type: "method",
        method: "onSessionAuthenticateResponse",
        topic: t,
        payload: e
      }), b(e) ? _this.events.emit(u("session_request", s), {
        result: e.result
      }) : $(e) && _this.events.emit(u("session_request", s), {
        error: e.error
      });
    }, _this.onSessionAuthenticateRequest = /*#__PURE__*/function () {
      var _ref52 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(t, e) {
        var _e$params2, s, i, r, o, a, c;
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              _e$params2 = e.params;
              s = _e$params2.requester;
              i = _e$params2.authPayload;
              r = _e$params2.expiryTimestamp;
              o = ee(JSON.stringify(e));
              _context46.next = 7;
              return _this.getVerifyContext(o, _this.client.metadata);
            case 7:
              a = _context46.sent;
              c = {
                requester: s,
                pairingTopic: t,
                id: e.id,
                authPayload: i,
                verifyContext: a,
                expiryTimestamp: r
              };
              _context46.next = 11;
              return _this.client.auth.requests.set(e.id, c);
            case 11:
              _this.client.events.emit("session_authenticate", {
                topic: t,
                params: e.params,
                id: e.id
              });
            case 12:
            case "end":
              return _context46.stop();
          }
        }, _callee46);
      }));
      return function (_x56, _x57) {
        return _ref52.apply(this, arguments);
      };
    }(), _this.addSessionRequestToSessionRequestQueue = function (t) {
      _this.sessionRequestQueue.queue.push(t);
    }, _this.cleanupAfterResponse = function (t) {
      _this.deletePendingSessionRequest(t.response.id, {
        message: "fulfilled",
        code: 0
      }), setTimeout(function () {
        _this.sessionRequestQueue.state = A.idle, _this.processSessionRequestQueue();
      }, Me(_this.requestQueueDelay));
    }, _this.cleanupPendingSentRequestsForTopic = function (_ref53) {
      var t = _ref53.topic,
        e = _ref53.error;
      var s = _this.client.core.history.pending;
      s.length > 0 && s.filter(function (i) {
        return i.topic === t && i.request.method === "wc_sessionRequest";
      }).forEach(function (i) {
        var r = i.request.id,
          o = u("session_request", r);
        if (_this.events.listenerCount(o) === 0) throw new Error("emitting ".concat(o, " without any listeners"));
        _this.events.emit(u("session_request", i.request.id), {
          error: e
        });
      });
    }, _this.processSessionRequestQueue = function () {
      if (_this.sessionRequestQueue.state === A.active) {
        _this.client.logger.info("session request queue is already active.");
        return;
      }
      var t = _this.sessionRequestQueue.queue[0];
      if (!t) {
        _this.client.logger.info("session request queue is empty.");
        return;
      }
      try {
        _this.sessionRequestQueue.state = A.active, _this.client.events.emit("session_request", t);
      } catch (e) {
        _this.client.logger.error(e);
      }
    }, _this.onPairingCreated = function (t) {
      if (t.methods && _this.expectedPairingMethodMap.set(t.topic, t.methods), t.active) return;
      var e = _this.client.proposal.getAll().find(function (s) {
        return s.pairingTopic === t.topic;
      });
      e && _this.onSessionProposeRequest(t.topic, me("wc_sessionPropose", {
        requiredNamespaces: e.requiredNamespaces,
        optionalNamespaces: e.optionalNamespaces,
        relays: e.relays,
        proposer: e.proposer,
        sessionProperties: e.sessionProperties
      }, e.id));
    }, _this.isValidConnect = /*#__PURE__*/function () {
      var _ref54 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(t) {
        var _l4, a, e, s, i, r, o, _l5, _a2;
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              if (T(t)) {
                _context47.next = 3;
                break;
              }
              _l4 = l("MISSING_OR_INVALID", "connect() params: ".concat(JSON.stringify(t))), a = _l4.message;
              throw new Error(a);
            case 3:
              e = t.pairingTopic, s = t.requiredNamespaces, i = t.optionalNamespaces, r = t.sessionProperties, o = t.relays;
              _context47.t0 = Y(e);
              if (_context47.t0) {
                _context47.next = 8;
                break;
              }
              _context47.next = 8;
              return _this.isValidPairingTopic(e);
            case 8:
              if (St(o, !0)) {
                _context47.next = 11;
                break;
              }
              _l5 = l("MISSING_OR_INVALID", "connect() relays: ".concat(o)), _a2 = _l5.message;
              throw new Error(_a2);
            case 11:
              !Y(s) && Ae(s) !== 0 && _this.validateNamespaces(s, "requiredNamespaces"), !Y(i) && Ae(i) !== 0 && _this.validateNamespaces(i, "optionalNamespaces"), Y(r) || _this.validateSessionProps(r, "sessionProperties");
            case 12:
            case "end":
              return _context47.stop();
          }
        }, _callee47);
      }));
      return function (_x58) {
        return _ref54.apply(this, arguments);
      };
    }(), _this.validateNamespaces = function (t, e) {
      var s = Et(t, "connect()", e);
      if (s) throw new Error(s.message);
    }, _this.isValidApprove = /*#__PURE__*/function () {
      var _ref55 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(t) {
        var e, s, i, r, o, a, c, _l6, d;
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              if (T(t)) {
                _context48.next = 2;
                break;
              }
              throw new Error(l("MISSING_OR_INVALID", "approve() params: ".concat(t)).message);
            case 2:
              e = t.id, s = t.namespaces, i = t.relayProtocol, r = t.sessionProperties;
              _this.checkRecentlyDeleted(e);
              _context48.next = 6;
              return _this.isValidProposalId(e);
            case 6:
              o = _this.client.proposal.get(e), a = ye(s, "approve()");
              if (!a) {
                _context48.next = 9;
                break;
              }
              throw new Error(a.message);
            case 9:
              c = Ve(o.requiredNamespaces, s, "approve()");
              if (!c) {
                _context48.next = 12;
                break;
              }
              throw new Error(c.message);
            case 12:
              if (V(i, !0)) {
                _context48.next = 15;
                break;
              }
              _l6 = l("MISSING_OR_INVALID", "approve() relayProtocol: ".concat(i)), d = _l6.message;
              throw new Error(d);
            case 15:
              Y(r) || _this.validateSessionProps(r, "sessionProperties");
            case 16:
            case "end":
              return _context48.stop();
          }
        }, _callee48);
      }));
      return function (_x59) {
        return _ref55.apply(this, arguments);
      };
    }(), _this.isValidReject = /*#__PURE__*/function () {
      var _ref56 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(t) {
        var _l7, i, e, s, _l8, _i4;
        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              if (T(t)) {
                _context49.next = 3;
                break;
              }
              _l7 = l("MISSING_OR_INVALID", "reject() params: ".concat(t)), i = _l7.message;
              throw new Error(i);
            case 3:
              e = t.id, s = t.reason;
              _this.checkRecentlyDeleted(e);
              _context49.next = 7;
              return _this.isValidProposalId(e);
            case 7:
              if (_t(s)) {
                _context49.next = 10;
                break;
              }
              _l8 = l("MISSING_OR_INVALID", "reject() reason: ".concat(JSON.stringify(s))), _i4 = _l8.message;
              throw new Error(_i4);
            case 10:
            case "end":
              return _context49.stop();
          }
        }, _callee49);
      }));
      return function (_x60) {
        return _ref56.apply(this, arguments);
      };
    }(), _this.isValidSessionSettleRequest = function (t) {
      if (!T(t)) {
        var _l9 = l("MISSING_OR_INVALID", "onSessionSettleRequest() params: ".concat(t)),
          c = _l9.message;
        throw new Error(c);
      }
      var e = t.relay,
        s = t.controller,
        i = t.namespaces,
        r = t.expiry;
      if (!Rt(e)) {
        var _l10 = l("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string"),
          _c = _l10.message;
        throw new Error(_c);
      }
      var o = It(s, "onSessionSettleRequest()");
      if (o) throw new Error(o.message);
      var a = ye(i, "onSessionSettleRequest()");
      if (a) throw new Error(a.message);
      if (G(r)) {
        var _l11 = l("EXPIRED", "onSessionSettleRequest()"),
          _c2 = _l11.message;
        throw new Error(_c2);
      }
    }, _this.isValidUpdate = /*#__PURE__*/function () {
      var _ref57 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(t) {
        var _l12, a, e, s, i, r, o;
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              if (T(t)) {
                _context50.next = 3;
                break;
              }
              _l12 = l("MISSING_OR_INVALID", "update() params: ".concat(t)), a = _l12.message;
              throw new Error(a);
            case 3:
              e = t.topic, s = t.namespaces;
              _this.checkRecentlyDeleted(e);
              _context50.next = 7;
              return _this.isValidSessionTopic(e);
            case 7:
              i = _this.client.session.get(e), r = ye(s, "update()");
              if (!r) {
                _context50.next = 10;
                break;
              }
              throw new Error(r.message);
            case 10:
              o = Ve(i.requiredNamespaces, s, "update()");
              if (!o) {
                _context50.next = 13;
                break;
              }
              throw new Error(o.message);
            case 13:
            case "end":
              return _context50.stop();
          }
        }, _callee50);
      }));
      return function (_x61) {
        return _ref57.apply(this, arguments);
      };
    }(), _this.isValidExtend = /*#__PURE__*/function () {
      var _ref58 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(t) {
        var _l13, s, e;
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              if (T(t)) {
                _context51.next = 3;
                break;
              }
              _l13 = l("MISSING_OR_INVALID", "extend() params: ".concat(t)), s = _l13.message;
              throw new Error(s);
            case 3:
              e = t.topic;
              _this.checkRecentlyDeleted(e);
              _context51.next = 7;
              return _this.isValidSessionTopic(e);
            case 7:
            case "end":
              return _context51.stop();
          }
        }, _callee51);
      }));
      return function (_x62) {
        return _ref58.apply(this, arguments);
      };
    }(), _this.isValidRequest = /*#__PURE__*/function () {
      var _ref59 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(t) {
        var _l14, a, e, s, i, r, _this$client$session$2, o, _l15, _a3, _l16, _a4, _l17, _a5, _l18, _a6;
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              if (T(t)) {
                _context52.next = 3;
                break;
              }
              _l14 = l("MISSING_OR_INVALID", "request() params: ".concat(t)), a = _l14.message;
              throw new Error(a);
            case 3:
              e = t.topic, s = t.request, i = t.chainId, r = t.expiry;
              _this.checkRecentlyDeleted(e);
              _context52.next = 7;
              return _this.isValidSessionTopic(e);
            case 7:
              _this$client$session$2 = _this.client.session.get(e), o = _this$client$session$2.namespaces;
              if (Ce(o, i)) {
                _context52.next = 11;
                break;
              }
              _l15 = l("MISSING_OR_INVALID", "request() chainId: ".concat(i)), _a3 = _l15.message;
              throw new Error(_a3);
            case 11:
              if (ft(s)) {
                _context52.next = 14;
                break;
              }
              _l16 = l("MISSING_OR_INVALID", "request() ".concat(JSON.stringify(s))), _a4 = _l16.message;
              throw new Error(_a4);
            case 14:
              if (qt(o, i, s.method)) {
                _context52.next = 17;
                break;
              }
              _l17 = l("MISSING_OR_INVALID", "request() method: ".concat(s.method)), _a5 = _l17.message;
              throw new Error(_a5);
            case 17:
              if (!(r && !Nt(r, re))) {
                _context52.next = 20;
                break;
              }
              _l18 = l("MISSING_OR_INVALID", "request() expiry: ".concat(r, ". Expiry must be a number (in seconds) between ").concat(re.min, " and ").concat(re.max)), _a6 = _l18.message;
              throw new Error(_a6);
            case 20:
            case "end":
              return _context52.stop();
          }
        }, _callee52);
      }));
      return function (_x63) {
        return _ref59.apply(this, arguments);
      };
    }(), _this.isValidRespond = /*#__PURE__*/function () {
      var _ref60 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(t) {
        var e, _l19, r, s, i, _l20, _r;
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              if (T(t)) {
                _context53.next = 3;
                break;
              }
              _l19 = l("MISSING_OR_INVALID", "respond() params: ".concat(t)), r = _l19.message;
              throw new Error(r);
            case 3:
              s = t.topic, i = t.response;
              _context53.prev = 4;
              _context53.next = 7;
              return _this.isValidSessionTopic(s);
            case 7:
              _context53.next = 12;
              break;
            case 9:
              _context53.prev = 9;
              _context53.t0 = _context53["catch"](4);
              throw (e = t === null || t === void 0 ? void 0 : t.response) != null && e.id && _this.cleanupAfterResponse(t), _context53.t0;
            case 12:
              if (Pt(i)) {
                _context53.next = 15;
                break;
              }
              _l20 = l("MISSING_OR_INVALID", "respond() response: ".concat(JSON.stringify(i))), _r = _l20.message;
              throw new Error(_r);
            case 15:
            case "end":
              return _context53.stop();
          }
        }, _callee53, null, [[4, 9]]);
      }));
      return function (_x64) {
        return _ref60.apply(this, arguments);
      };
    }(), _this.isValidPing = /*#__PURE__*/function () {
      var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(t) {
        var _l21, s, e;
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              if (T(t)) {
                _context54.next = 3;
                break;
              }
              _l21 = l("MISSING_OR_INVALID", "ping() params: ".concat(t)), s = _l21.message;
              throw new Error(s);
            case 3:
              e = t.topic;
              _context54.next = 6;
              return _this.isValidSessionOrPairingTopic(e);
            case 6:
            case "end":
              return _context54.stop();
          }
        }, _callee54);
      }));
      return function (_x65) {
        return _ref61.apply(this, arguments);
      };
    }(), _this.isValidEmit = /*#__PURE__*/function () {
      var _ref62 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(t) {
        var _l22, o, e, s, i, _this$client$session$3, r, _l23, _o, _l24, _o2, _l25, _o3;
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              if (T(t)) {
                _context55.next = 3;
                break;
              }
              _l22 = l("MISSING_OR_INVALID", "emit() params: ".concat(t)), o = _l22.message;
              throw new Error(o);
            case 3:
              e = t.topic, s = t.event, i = t.chainId;
              _context55.next = 6;
              return _this.isValidSessionTopic(e);
            case 6:
              _this$client$session$3 = _this.client.session.get(e), r = _this$client$session$3.namespaces;
              if (Ce(r, i)) {
                _context55.next = 10;
                break;
              }
              _l23 = l("MISSING_OR_INVALID", "emit() chainId: ".concat(i)), _o = _l23.message;
              throw new Error(_o);
            case 10:
              if (vt(s)) {
                _context55.next = 13;
                break;
              }
              _l24 = l("MISSING_OR_INVALID", "emit() event: ".concat(JSON.stringify(s))), _o2 = _l24.message;
              throw new Error(_o2);
            case 13:
              if (Ot(r, i, s.name)) {
                _context55.next = 16;
                break;
              }
              _l25 = l("MISSING_OR_INVALID", "emit() event: ".concat(JSON.stringify(s))), _o3 = _l25.message;
              throw new Error(_o3);
            case 16:
            case "end":
              return _context55.stop();
          }
        }, _callee55);
      }));
      return function (_x66) {
        return _ref62.apply(this, arguments);
      };
    }(), _this.isValidDisconnect = /*#__PURE__*/function () {
      var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(t) {
        var _l26, s, e;
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) switch (_context56.prev = _context56.next) {
            case 0:
              if (T(t)) {
                _context56.next = 3;
                break;
              }
              _l26 = l("MISSING_OR_INVALID", "disconnect() params: ".concat(t)), s = _l26.message;
              throw new Error(s);
            case 3:
              e = t.topic;
              _context56.next = 6;
              return _this.isValidSessionOrPairingTopic(e);
            case 6:
            case "end":
              return _context56.stop();
          }
        }, _callee56);
      }));
      return function (_x67) {
        return _ref63.apply(this, arguments);
      };
    }(), _this.isValidAuthenticate = function (t) {
      var e = t.chains,
        s = t.uri,
        i = t.domain,
        r = t.nonce;
      if (!Array.isArray(e) || e.length === 0) throw new Error("chains is required and must be a non-empty array");
      if (!V(s, !1)) throw new Error("uri is required parameter");
      if (!V(i, !1)) throw new Error("domain is required parameter");
      if (!V(r, !1)) throw new Error("nonce is required parameter");
      if (_toConsumableArray(new Set(e.map(function (a) {
        return ge(a).namespace;
      }))).length > 1) throw new Error("Multi-namespace requests are not supported. Please request single namespace only.");
      var _ge2 = ge(e[0]),
        o = _ge2.namespace;
      if (o !== "eip155") throw new Error("Only eip155 namespace is supported for authenticated sessions. Please use .connect() for non-eip155 chains.");
    }, _this.getVerifyContext = /*#__PURE__*/function () {
      var _ref64 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(t, e) {
        var s, i;
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) switch (_context57.prev = _context57.next) {
            case 0:
              s = {
                verified: {
                  verifyUrl: e.verifyUrl || st,
                  validation: "UNKNOWN",
                  origin: e.url || ""
                }
              };
              _context57.prev = 1;
              _context57.next = 4;
              return _this.client.core.verify.resolve({
                attestationId: t,
                verifyUrl: e.verifyUrl
              });
            case 4:
              i = _context57.sent;
              i && (s.verified.origin = i.origin, s.verified.isScam = i.isScam, s.verified.validation = i.origin === new URL(e.url).origin ? "VALID" : "INVALID");
              _context57.next = 11;
              break;
            case 8:
              _context57.prev = 8;
              _context57.t0 = _context57["catch"](1);
              _this.client.logger.info(_context57.t0);
            case 11:
              return _context57.abrupt("return", (_this.client.logger.info("Verify context: ".concat(JSON.stringify(s))), s));
            case 12:
            case "end":
              return _context57.stop();
          }
        }, _callee57, null, [[1, 8]]);
      }));
      return function (_x68, _x69) {
        return _ref64.apply(this, arguments);
      };
    }(), _this.validateSessionProps = function (t, e) {
      Object.values(t).forEach(function (s) {
        if (!V(s, !1)) {
          var _l27 = l("MISSING_OR_INVALID", "".concat(e, " must be in Record<string, string> format. Received: ").concat(JSON.stringify(s))),
            i = _l27.message;
          throw new Error(i);
        }
      });
    }, _this.getPendingAuthRequest = function (t) {
      var e = _this.client.auth.requests.get(t);
      return typeof e == "object" ? e : void 0;
    }, _this.addToRecentlyDeleted = function (t, e) {
      if (_this.recentlyDeletedMap.set(t, e), _this.recentlyDeletedMap.size >= _this.recentlyDeletedLimit) {
        var s = 0;
        var i = _this.recentlyDeletedLimit / 2;
        var _iterator4 = _createForOfIteratorHelper(_this.recentlyDeletedMap.keys()),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var r = _step4.value;
            if (s++ >= i) break;
            _this.recentlyDeletedMap.delete(r);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }, _this.checkRecentlyDeleted = function (t) {
      var e = _this.recentlyDeletedMap.get(t);
      if (e) {
        var _l28 = l("MISSING_OR_INVALID", "Record was recently deleted - ".concat(e, ": ").concat(t)),
          s = _l28.message;
        throw new Error(s);
      }
    };
    return _this;
  }
  _createClass(Wt, [{
    key: "isInitialized",
    value: function () {
      var _isInitialized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58() {
        var _l29, n;
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) switch (_context58.prev = _context58.next) {
            case 0:
              if (this.initialized) {
                _context58.next = 3;
                break;
              }
              _l29 = l("NOT_INITIALIZED", this.name), n = _l29.message;
              throw new Error(n);
            case 3:
              _context58.next = 5;
              return this.client.core.relayer.confirmOnlineStateOrThrow();
            case 5:
            case "end":
              return _context58.stop();
          }
        }, _callee58, this);
      }));
      function isInitialized() {
        return _isInitialized.apply(this, arguments);
      }
      return isInitialized;
    }()
  }, {
    key: "registerRelayerEvents",
    value: function registerRelayerEvents() {
      var _this2 = this;
      this.client.core.relayer.on(qe.message, /*#__PURE__*/function () {
        var _ref65 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(n) {
          var t, e, _ref66, s, i;
          return _regeneratorRuntime.wrap(function _callee59$(_context59) {
            while (1) switch (_context59.prev = _context59.next) {
              case 0:
                t = n.topic;
                e = n.message;
                _ref66 = _this2.client.auth.authKeys.keys.includes(J) ? _this2.client.auth.authKeys.get(J) : {
                  responseTopic: void 0,
                  publicKey: void 0
                };
                s = _ref66.publicKey;
                _context59.next = 6;
                return _this2.client.core.crypto.decode(t, e, {
                  receiverPublicKey: s
                });
              case 6:
                i = _context59.sent;
                _context59.prev = 7;
                if (!Mt(i)) {
                  _context59.next = 12;
                  break;
                }
                _this2.client.core.history.set(t, i), _this2.onRelayEventRequest({
                  topic: t,
                  payload: i
                });
                _context59.next = 21;
                break;
              case 12:
                if (!Kt(i)) {
                  _context59.next = 20;
                  break;
                }
                _context59.next = 15;
                return _this2.client.core.history.resolve(i);
              case 15:
                _context59.next = 17;
                return _this2.onRelayEventResponse({
                  topic: t,
                  payload: i
                });
              case 17:
                _this2.client.core.history.delete(t, i.id);
                _context59.next = 21;
                break;
              case 20:
                _this2.onRelayEventUnknownPayload({
                  topic: t,
                  payload: i
                });
              case 21:
                _context59.next = 26;
                break;
              case 23:
                _context59.prev = 23;
                _context59.t0 = _context59["catch"](7);
                _this2.client.logger.error(_context59.t0);
              case 26:
              case "end":
                return _context59.stop();
            }
          }, _callee59, null, [[7, 23]]);
        }));
        return function (_x70) {
          return _ref65.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "registerExpirerEvents",
    value: function registerExpirerEvents() {
      var _this3 = this;
      this.client.core.expirer.on(it.expired, /*#__PURE__*/function () {
        var _ref67 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(n) {
          var _Tt, t, e;
          return _regeneratorRuntime.wrap(function _callee60$(_context60) {
            while (1) switch (_context60.prev = _context60.next) {
              case 0:
                _Tt = Tt(n.target), t = _Tt.topic, e = _Tt.id;
                if (!(e && _this3.client.pendingRequest.keys.includes(e))) {
                  _context60.next = 5;
                  break;
                }
                _context60.next = 4;
                return _this3.deletePendingSessionRequest(e, l("EXPIRED"), !0);
              case 4:
                return _context60.abrupt("return", _context60.sent);
              case 5:
                if (!t) {
                  _context60.next = 13;
                  break;
                }
                _context60.t0 = _this3.client.session.keys.includes(t);
                if (!_context60.t0) {
                  _context60.next = 11;
                  break;
                }
                _context60.next = 10;
                return _this3.deleteSession({
                  topic: t,
                  expirerHasDeleted: !0
                });
              case 10:
                _this3.client.events.emit("session_expire", {
                  topic: t
                });
              case 11:
                _context60.next = 18;
                break;
              case 13:
                _context60.t1 = e;
                if (!_context60.t1) {
                  _context60.next = 18;
                  break;
                }
                _context60.next = 17;
                return _this3.deleteProposal(e, !0);
              case 17:
                _this3.client.events.emit("proposal_expire", {
                  id: e
                });
              case 18:
              case "end":
                return _context60.stop();
            }
          }, _callee60);
        }));
        return function (_x71) {
          return _ref67.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "registerPairingEvents",
    value: function registerPairingEvents() {
      var _this4 = this;
      this.client.core.pairing.events.on(Ne.create, function (n) {
        return _this4.onPairingCreated(n);
      }), this.client.core.pairing.events.on(Ne.delete, function (n) {
        _this4.addToRecentlyDeleted(n.topic, "pairing");
      });
    }
  }, {
    key: "isValidPairingTopic",
    value: function isValidPairingTopic(n) {
      if (!V(n, !1)) {
        var _l30 = l("MISSING_OR_INVALID", "pairing topic should be a string: ".concat(n)),
          t = _l30.message;
        throw new Error(t);
      }
      if (!this.client.core.pairing.pairings.keys.includes(n)) {
        var _l31 = l("NO_MATCHING_KEY", "pairing topic doesn't exist: ".concat(n)),
          _t2 = _l31.message;
        throw new Error(_t2);
      }
      if (G(this.client.core.pairing.pairings.get(n).expiry)) {
        var _l32 = l("EXPIRED", "pairing topic: ".concat(n)),
          _t3 = _l32.message;
        throw new Error(_t3);
      }
    }
  }, {
    key: "isValidSessionTopic",
    value: function () {
      var _isValidSessionTopic = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(n) {
        var _l33, t, _l34, _t4, _l35, _t5, _l36, _t6;
        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) switch (_context61.prev = _context61.next) {
            case 0:
              if (V(n, !1)) {
                _context61.next = 3;
                break;
              }
              _l33 = l("MISSING_OR_INVALID", "session topic should be a string: ".concat(n)), t = _l33.message;
              throw new Error(t);
            case 3:
              if (!(this.checkRecentlyDeleted(n), !this.client.session.keys.includes(n))) {
                _context61.next = 6;
                break;
              }
              _l34 = l("NO_MATCHING_KEY", "session topic doesn't exist: ".concat(n)), _t4 = _l34.message;
              throw new Error(_t4);
            case 6:
              if (!G(this.client.session.get(n).expiry)) {
                _context61.next = 11;
                break;
              }
              _context61.next = 9;
              return this.deleteSession({
                topic: n
              });
            case 9:
              _l35 = l("EXPIRED", "session topic: ".concat(n)), _t5 = _l35.message;
              throw new Error(_t5);
            case 11:
              if (this.client.core.crypto.keychain.has(n)) {
                _context61.next = 16;
                break;
              }
              _l36 = l("MISSING_OR_INVALID", "session topic does not exist in keychain: ".concat(n)), _t6 = _l36.message;
              _context61.next = 15;
              return this.deleteSession({
                topic: n
              });
            case 15:
              throw new Error(_t6);
            case 16:
            case "end":
              return _context61.stop();
          }
        }, _callee61, this);
      }));
      function isValidSessionTopic(_x72) {
        return _isValidSessionTopic.apply(this, arguments);
      }
      return isValidSessionTopic;
    }()
  }, {
    key: "isValidSessionOrPairingTopic",
    value: function () {
      var _isValidSessionOrPairingTopic = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(n) {
        var _l37, t, _l38, _t7;
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              if (!(this.checkRecentlyDeleted(n), this.client.session.keys.includes(n))) {
                _context62.next = 5;
                break;
              }
              _context62.next = 3;
              return this.isValidSessionTopic(n);
            case 3:
              _context62.next = 16;
              break;
            case 5:
              if (!this.client.core.pairing.pairings.keys.includes(n)) {
                _context62.next = 9;
                break;
              }
              this.isValidPairingTopic(n);
              _context62.next = 16;
              break;
            case 9:
              if (!V(n, !1)) {
                _context62.next = 14;
                break;
              }
              _l37 = l("NO_MATCHING_KEY", "session or pairing topic doesn't exist: ".concat(n)), t = _l37.message;
              throw new Error(t);
            case 14:
              _l38 = l("MISSING_OR_INVALID", "session or pairing topic should be a string: ".concat(n)), _t7 = _l38.message;
              throw new Error(_t7);
            case 16:
            case "end":
              return _context62.stop();
          }
        }, _callee62, this);
      }));
      function isValidSessionOrPairingTopic(_x73) {
        return _isValidSessionOrPairingTopic.apply(this, arguments);
      }
      return isValidSessionOrPairingTopic;
    }()
  }, {
    key: "isValidProposalId",
    value: function () {
      var _isValidProposalId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(n) {
        var _l39, t, _l40, _t8, _l41, _t9;
        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              if (Dt(n)) {
                _context63.next = 3;
                break;
              }
              _l39 = l("MISSING_OR_INVALID", "proposal id should be a number: ".concat(n)), t = _l39.message;
              throw new Error(t);
            case 3:
              if (this.client.proposal.keys.includes(n)) {
                _context63.next = 6;
                break;
              }
              _l40 = l("NO_MATCHING_KEY", "proposal id doesn't exist: ".concat(n)), _t8 = _l40.message;
              throw new Error(_t8);
            case 6:
              if (!G(this.client.proposal.get(n).expiryTimestamp)) {
                _context63.next = 11;
                break;
              }
              _context63.next = 9;
              return this.deleteProposal(n);
            case 9:
              _l41 = l("EXPIRED", "proposal id: ".concat(n)), _t9 = _l41.message;
              throw new Error(_t9);
            case 11:
            case "end":
              return _context63.stop();
          }
        }, _callee63, this);
      }));
      function isValidProposalId(_x74) {
        return _isValidProposalId.apply(this, arguments);
      }
      return isValidProposalId;
    }()
  }]);
  return Wt;
}(lt);
var Zt = /*#__PURE__*/function (_K) {
  _inherits(Zt, _K);
  var _super2 = _createSuper(Zt);
  function Zt(n, t) {
    var _this5;
    _classCallCheck(this, Zt);
    _this5 = _super2.call(this, n, t, Ke, se), _this5.core = n, _this5.logger = t;
    return _this5;
  }
  return _createClass(Zt);
}(K);
var We = /*#__PURE__*/function (_K2) {
  _inherits(We, _K2);
  var _super3 = _createSuper(We);
  function We(n, t) {
    var _this6;
    _classCallCheck(this, We);
    _this6 = _super3.call(this, n, t, Ge, se), _this6.core = n, _this6.logger = t;
    return _this6;
  }
  return _createClass(We);
}(K);
var es = /*#__PURE__*/function (_K3) {
  _inherits(es, _K3);
  var _super4 = _createSuper(es);
  function es(n, t) {
    var _this7;
    _classCallCheck(this, es);
    _this7 = _super4.call(this, n, t, Fe, se, function (e) {
      return e.id;
    }), _this7.core = n, _this7.logger = t;
    return _this7;
  }
  return _createClass(es);
}(K);
var ts = /*#__PURE__*/function (_K4) {
  _inherits(ts, _K4);
  var _super5 = _createSuper(ts);
  function ts(n, t) {
    var _this8;
    _classCallCheck(this, ts);
    _this8 = _super5.call(this, n, t, He, X, function () {
      return J;
    }), _this8.core = n, _this8.logger = t;
    return _this8;
  }
  return _createClass(ts);
}(K);
var ss = /*#__PURE__*/function (_K5) {
  _inherits(ss, _K5);
  var _super6 = _createSuper(ss);
  function ss(n, t) {
    var _this9;
    _classCallCheck(this, ss);
    _this9 = _super6.call(this, n, t, Ye, X), _this9.core = n, _this9.logger = t;
    return _this9;
  }
  return _createClass(ss);
}(K);
var is = /*#__PURE__*/function (_K6) {
  _inherits(is, _K6);
  var _super7 = _createSuper(is);
  function is(n, t) {
    var _this10;
    _classCallCheck(this, is);
    _this10 = _super7.call(this, n, t, Xe, X, function (e) {
      return e.id;
    }), _this10.core = n, _this10.logger = t;
    return _this10;
  }
  return _createClass(is);
}(K);
var rs = /*#__PURE__*/function () {
  function rs(n, t) {
    _classCallCheck(this, rs);
    this.core = n, this.logger = t, this.authKeys = new ts(this.core, this.logger), this.pairingTopics = new ss(this.core, this.logger), this.requests = new is(this.core, this.logger);
  }
  _createClass(rs, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64() {
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              _context64.next = 2;
              return this.authKeys.init();
            case 2:
              _context64.next = 4;
              return this.pairingTopics.init();
            case 4:
              _context64.next = 6;
              return this.requests.init();
            case 6:
            case "end":
              return _context64.stop();
          }
        }, _callee64, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }]);
  return rs;
}();
var ne = /*#__PURE__*/function (_ht) {
  _inherits(ne, _ht);
  var _super8 = _createSuper(ne);
  function ne(n) {
    var _this11;
    _classCallCheck(this, ne);
    _this11 = _super8.call(this, n), _this11.protocol = Se, _this11.version = Ee, _this11.name = ie.name, _this11.events = new Vt(), _this11.on = function (e, s) {
      return _this11.events.on(e, s);
    }, _this11.once = function (e, s) {
      return _this11.events.once(e, s);
    }, _this11.off = function (e, s) {
      return _this11.events.off(e, s);
    }, _this11.removeListener = function (e, s) {
      return _this11.events.removeListener(e, s);
    }, _this11.removeAllListeners = function (e) {
      return _this11.events.removeAllListeners(e);
    }, _this11.connect = /*#__PURE__*/function () {
      var _ref68 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(e) {
        return _regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) switch (_context65.prev = _context65.next) {
            case 0:
              _context65.prev = 0;
              _context65.next = 3;
              return _this11.engine.connect(e);
            case 3:
              return _context65.abrupt("return", _context65.sent);
            case 6:
              _context65.prev = 6;
              _context65.t0 = _context65["catch"](0);
              throw _this11.logger.error(_context65.t0.message), _context65.t0;
            case 9:
            case "end":
              return _context65.stop();
          }
        }, _callee65, null, [[0, 6]]);
      }));
      return function (_x75) {
        return _ref68.apply(this, arguments);
      };
    }(), _this11.pair = /*#__PURE__*/function () {
      var _ref69 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(e) {
        return _regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              _context66.prev = 0;
              _context66.next = 3;
              return _this11.engine.pair(e);
            case 3:
              return _context66.abrupt("return", _context66.sent);
            case 6:
              _context66.prev = 6;
              _context66.t0 = _context66["catch"](0);
              throw _this11.logger.error(_context66.t0.message), _context66.t0;
            case 9:
            case "end":
              return _context66.stop();
          }
        }, _callee66, null, [[0, 6]]);
      }));
      return function (_x76) {
        return _ref69.apply(this, arguments);
      };
    }(), _this11.approve = /*#__PURE__*/function () {
      var _ref70 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(e) {
        return _regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) switch (_context67.prev = _context67.next) {
            case 0:
              _context67.prev = 0;
              _context67.next = 3;
              return _this11.engine.approve(e);
            case 3:
              return _context67.abrupt("return", _context67.sent);
            case 6:
              _context67.prev = 6;
              _context67.t0 = _context67["catch"](0);
              throw _this11.logger.error(_context67.t0.message), _context67.t0;
            case 9:
            case "end":
              return _context67.stop();
          }
        }, _callee67, null, [[0, 6]]);
      }));
      return function (_x77) {
        return _ref70.apply(this, arguments);
      };
    }(), _this11.reject = /*#__PURE__*/function () {
      var _ref71 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(e) {
        return _regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) switch (_context68.prev = _context68.next) {
            case 0:
              _context68.prev = 0;
              _context68.next = 3;
              return _this11.engine.reject(e);
            case 3:
              return _context68.abrupt("return", _context68.sent);
            case 6:
              _context68.prev = 6;
              _context68.t0 = _context68["catch"](0);
              throw _this11.logger.error(_context68.t0.message), _context68.t0;
            case 9:
            case "end":
              return _context68.stop();
          }
        }, _callee68, null, [[0, 6]]);
      }));
      return function (_x78) {
        return _ref71.apply(this, arguments);
      };
    }(), _this11.update = /*#__PURE__*/function () {
      var _ref72 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(e) {
        return _regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              _context69.prev = 0;
              _context69.next = 3;
              return _this11.engine.update(e);
            case 3:
              return _context69.abrupt("return", _context69.sent);
            case 6:
              _context69.prev = 6;
              _context69.t0 = _context69["catch"](0);
              throw _this11.logger.error(_context69.t0.message), _context69.t0;
            case 9:
            case "end":
              return _context69.stop();
          }
        }, _callee69, null, [[0, 6]]);
      }));
      return function (_x79) {
        return _ref72.apply(this, arguments);
      };
    }(), _this11.extend = /*#__PURE__*/function () {
      var _ref73 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70(e) {
        return _regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              _context70.prev = 0;
              _context70.next = 3;
              return _this11.engine.extend(e);
            case 3:
              return _context70.abrupt("return", _context70.sent);
            case 6:
              _context70.prev = 6;
              _context70.t0 = _context70["catch"](0);
              throw _this11.logger.error(_context70.t0.message), _context70.t0;
            case 9:
            case "end":
              return _context70.stop();
          }
        }, _callee70, null, [[0, 6]]);
      }));
      return function (_x80) {
        return _ref73.apply(this, arguments);
      };
    }(), _this11.request = /*#__PURE__*/function () {
      var _ref74 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71(e) {
        return _regeneratorRuntime.wrap(function _callee71$(_context71) {
          while (1) switch (_context71.prev = _context71.next) {
            case 0:
              _context71.prev = 0;
              _context71.next = 3;
              return _this11.engine.request(e);
            case 3:
              return _context71.abrupt("return", _context71.sent);
            case 6:
              _context71.prev = 6;
              _context71.t0 = _context71["catch"](0);
              throw _this11.logger.error(_context71.t0.message), _context71.t0;
            case 9:
            case "end":
              return _context71.stop();
          }
        }, _callee71, null, [[0, 6]]);
      }));
      return function (_x81) {
        return _ref74.apply(this, arguments);
      };
    }(), _this11.respond = /*#__PURE__*/function () {
      var _ref75 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72(e) {
        return _regeneratorRuntime.wrap(function _callee72$(_context72) {
          while (1) switch (_context72.prev = _context72.next) {
            case 0:
              _context72.prev = 0;
              _context72.next = 3;
              return _this11.engine.respond(e);
            case 3:
              return _context72.abrupt("return", _context72.sent);
            case 6:
              _context72.prev = 6;
              _context72.t0 = _context72["catch"](0);
              throw _this11.logger.error(_context72.t0.message), _context72.t0;
            case 9:
            case "end":
              return _context72.stop();
          }
        }, _callee72, null, [[0, 6]]);
      }));
      return function (_x82) {
        return _ref75.apply(this, arguments);
      };
    }(), _this11.ping = /*#__PURE__*/function () {
      var _ref76 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73(e) {
        return _regeneratorRuntime.wrap(function _callee73$(_context73) {
          while (1) switch (_context73.prev = _context73.next) {
            case 0:
              _context73.prev = 0;
              _context73.next = 3;
              return _this11.engine.ping(e);
            case 3:
              return _context73.abrupt("return", _context73.sent);
            case 6:
              _context73.prev = 6;
              _context73.t0 = _context73["catch"](0);
              throw _this11.logger.error(_context73.t0.message), _context73.t0;
            case 9:
            case "end":
              return _context73.stop();
          }
        }, _callee73, null, [[0, 6]]);
      }));
      return function (_x83) {
        return _ref76.apply(this, arguments);
      };
    }(), _this11.emit = /*#__PURE__*/function () {
      var _ref77 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74(e) {
        return _regeneratorRuntime.wrap(function _callee74$(_context74) {
          while (1) switch (_context74.prev = _context74.next) {
            case 0:
              _context74.prev = 0;
              _context74.next = 3;
              return _this11.engine.emit(e);
            case 3:
              return _context74.abrupt("return", _context74.sent);
            case 6:
              _context74.prev = 6;
              _context74.t0 = _context74["catch"](0);
              throw _this11.logger.error(_context74.t0.message), _context74.t0;
            case 9:
            case "end":
              return _context74.stop();
          }
        }, _callee74, null, [[0, 6]]);
      }));
      return function (_x84) {
        return _ref77.apply(this, arguments);
      };
    }(), _this11.disconnect = /*#__PURE__*/function () {
      var _ref78 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75(e) {
        return _regeneratorRuntime.wrap(function _callee75$(_context75) {
          while (1) switch (_context75.prev = _context75.next) {
            case 0:
              _context75.prev = 0;
              _context75.next = 3;
              return _this11.engine.disconnect(e);
            case 3:
              return _context75.abrupt("return", _context75.sent);
            case 6:
              _context75.prev = 6;
              _context75.t0 = _context75["catch"](0);
              throw _this11.logger.error(_context75.t0.message), _context75.t0;
            case 9:
            case "end":
              return _context75.stop();
          }
        }, _callee75, null, [[0, 6]]);
      }));
      return function (_x85) {
        return _ref78.apply(this, arguments);
      };
    }(), _this11.find = function (e) {
      try {
        return _this11.engine.find(e);
      } catch (s) {
        throw _this11.logger.error(s.message), s;
      }
    }, _this11.getPendingSessionRequests = function () {
      try {
        return _this11.engine.getPendingSessionRequests();
      } catch (e) {
        throw _this11.logger.error(e.message), e;
      }
    }, _this11.authenticate = /*#__PURE__*/function () {
      var _ref79 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee76(e) {
        return _regeneratorRuntime.wrap(function _callee76$(_context76) {
          while (1) switch (_context76.prev = _context76.next) {
            case 0:
              _context76.prev = 0;
              _context76.next = 3;
              return _this11.engine.authenticate(e);
            case 3:
              return _context76.abrupt("return", _context76.sent);
            case 6:
              _context76.prev = 6;
              _context76.t0 = _context76["catch"](0);
              throw _this11.logger.error(_context76.t0.message), _context76.t0;
            case 9:
            case "end":
              return _context76.stop();
          }
        }, _callee76, null, [[0, 6]]);
      }));
      return function (_x86) {
        return _ref79.apply(this, arguments);
      };
    }(), _this11.formatAuthMessage = function (e) {
      try {
        return _this11.engine.formatAuthMessage(e);
      } catch (s) {
        throw _this11.logger.error(s.message), s;
      }
    }, _this11.approveSessionAuthenticate = /*#__PURE__*/function () {
      var _ref80 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee77(e) {
        return _regeneratorRuntime.wrap(function _callee77$(_context77) {
          while (1) switch (_context77.prev = _context77.next) {
            case 0:
              _context77.prev = 0;
              _context77.next = 3;
              return _this11.engine.approveSessionAuthenticate(e);
            case 3:
              return _context77.abrupt("return", _context77.sent);
            case 6:
              _context77.prev = 6;
              _context77.t0 = _context77["catch"](0);
              throw _this11.logger.error(_context77.t0.message), _context77.t0;
            case 9:
            case "end":
              return _context77.stop();
          }
        }, _callee77, null, [[0, 6]]);
      }));
      return function (_x87) {
        return _ref80.apply(this, arguments);
      };
    }(), _this11.rejectSessionAuthenticate = /*#__PURE__*/function () {
      var _ref81 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee78(e) {
        return _regeneratorRuntime.wrap(function _callee78$(_context78) {
          while (1) switch (_context78.prev = _context78.next) {
            case 0:
              _context78.prev = 0;
              _context78.next = 3;
              return _this11.engine.rejectSessionAuthenticate(e);
            case 3:
              return _context78.abrupt("return", _context78.sent);
            case 6:
              _context78.prev = 6;
              _context78.t0 = _context78["catch"](0);
              throw _this11.logger.error(_context78.t0.message), _context78.t0;
            case 9:
            case "end":
              return _context78.stop();
          }
        }, _callee78, null, [[0, 6]]);
      }));
      return function (_x88) {
        return _ref81.apply(this, arguments);
      };
    }(), _this11.name = (n === null || n === void 0 ? void 0 : n.name) || ie.name, _this11.metadata = (n === null || n === void 0 ? void 0 : n.metadata) || xt();
    var t = typeof (n === null || n === void 0 ? void 0 : n.logger) < "u" && typeof (n === null || n === void 0 ? void 0 : n.logger) != "string" ? n.logger : nt(ot({
      level: (n === null || n === void 0 ? void 0 : n.logger) || ie.logger
    }));
    _this11.core = (n === null || n === void 0 ? void 0 : n.core) || new rt(n), _this11.logger = at(t, _this11.name), _this11.session = new We(_this11.core, _this11.logger), _this11.proposal = new Zt(_this11.core, _this11.logger), _this11.pendingRequest = new es(_this11.core, _this11.logger), _this11.engine = new Wt(_assertThisInitialized(_this11)), _this11.auth = new rs(_this11.core, _this11.logger);
    return _this11;
  }
  _createClass(ne, [{
    key: "context",
    get: function get() {
      return ct(this.logger);
    }
  }, {
    key: "pairing",
    get: function get() {
      return this.core.pairing.pairings;
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee79() {
        return _regeneratorRuntime.wrap(function _callee79$(_context79) {
          while (1) switch (_context79.prev = _context79.next) {
            case 0:
              this.logger.trace("Initialized");
              _context79.prev = 1;
              _context79.next = 4;
              return this.core.start();
            case 4:
              _context79.next = 6;
              return this.session.init();
            case 6:
              _context79.next = 8;
              return this.proposal.init();
            case 8:
              _context79.next = 10;
              return this.pendingRequest.init();
            case 10:
              _context79.next = 12;
              return this.engine.init();
            case 12:
              _context79.next = 14;
              return this.auth.init();
            case 14:
              this.core.verify.init({
                verifyUrl: this.metadata.verifyUrl
              });
              this.logger.info("SignClient Initialization Success");
              _context79.next = 21;
              break;
            case 18:
              _context79.prev = 18;
              _context79.t0 = _context79["catch"](1);
              throw this.logger.info("SignClient Initialization Failure"), this.logger.error(_context79.t0.message), _context79.t0;
            case 21:
            case "end":
              return _context79.stop();
          }
        }, _callee79, this, [[1, 18]]);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }], [{
    key: "init",
    value: function () {
      var _init2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee80(n) {
        var t;
        return _regeneratorRuntime.wrap(function _callee80$(_context80) {
          while (1) switch (_context80.prev = _context80.next) {
            case 0:
              t = new ne(n);
              _context80.next = 3;
              return t.initialize();
            case 3:
              return _context80.abrupt("return", t);
            case 4:
            case "end":
              return _context80.stop();
          }
        }, _callee80);
      }));
      function init(_x89) {
        return _init2.apply(this, arguments);
      }
      return init;
    }()
  }]);
  return ne;
}(ht);
var ns = We,
  os = ne;
export { ze as AUTH_CONTEXT, He as AUTH_KEYS_CONTEXT, Ye as AUTH_PAIRING_TOPIC_CONTEXT, Qe as AUTH_PROTOCOL, J as AUTH_PUBLIC_KEY_NAME, Xe as AUTH_REQUEST_CONTEXT, X as AUTH_STORAGE_PREFIX, zt as AUTH_VERSION, ke as ENGINE_CONTEXT, A as ENGINE_QUEUE_STATES, q as ENGINE_RPC_OPTS, Ft as HISTORY_CONTEXT, kt as HISTORY_EVENTS, jt as HISTORY_STORAGE_VERSION, je as METHODS_TO_VERIFY, Ke as PROPOSAL_CONTEXT, Qt as PROPOSAL_EXPIRY, Ue as PROPOSAL_EXPIRY_MESSAGE, Fe as REQUEST_CONTEXT, Ge as SESSION_CONTEXT, L as SESSION_EXPIRY, re as SESSION_REQUEST_EXPIRY_BOUNDARIES, _e as SIGN_CLIENT_CONTEXT, ie as SIGN_CLIENT_DEFAULT, Ut as SIGN_CLIENT_EVENTS, Se as SIGN_CLIENT_PROTOCOL, Gt as SIGN_CLIENT_STORAGE_OPTIONS, se as SIGN_CLIENT_STORAGE_PREFIX, Ee as SIGN_CLIENT_VERSION, ns as SessionStore, os as SignClient, Re as WALLETCONNECT_DEEPLINK_CHOICE, ne as default };